/* ==========================================================================
   Possidónio Cachapa — Theme Interactivity & Dual-Language Engine (PT | EN)
   ========================================================================== */

let currentLang = 'pt';

// Helper to resolve asset URLs across Shopify CDN and Local Development
function resolveAsset(filename) {
  if (typeof window !== 'undefined' && window.ShopifyThemeAssets && window.ShopifyThemeAssets[filename]) {
    return window.ShopifyThemeAssets[filename];
  }
  return 'assets/' + filename;
}

// Complete Book Catalog Database (Bilingual Synopses, Metadata, Bookstore Links & Excerpt Samples)
const bookCatalogData = {
  "1": {
    title: "A Selva Dentro de Casa",
    year: "2024",
    genre_pt: "Romance",
    genre_en: "Novel",
    salesType: "external",
    price: "€18.00",
    badge_pt: "Disponível nas Livrarias",
    badge_en: "Available in Bookstores",
    cover: resolveAsset("selva-dentro-de-casa.webp"),
    synopsis_pt: "Enquanto o tio e a lembrança dos dias felizes o abandonam, esta criança-narrador enfrenta o desafio de sobreviver num país marcado por outras formas de violência, a começar pela que existe no seio da sua própria família.",
    synopsis_en: "As his uncle and memories of happy days leave him, this child narrator faces the challenge of surviving in a country marked by other forms of violence, starting within his own family.",
    links: [
      { name: "Livraria Bertrand", desc: "Livraria Oficial • Compra Online", url: "https://www.bertrand.pt/livro/a-selva-dentro-de-casa-possidonio-cachapa/30500076" },
      { name: "FNAC Portugal", desc: "Loja Online & Entrega Rápida", url: "https://www.fnac.pt/A-Selva-Dentro-de-Casa-Possidonio-Cachapa/a12046392" }
    ],
    excerpt: {
      hasChapterTitle: false,
      paragraphs: [
        "No dia seguinte, as mensagens dos soldados voltaram. De novo, a família se juntou em volta da camilha. Os soldados iniciaram a ladainha permitida, um a um, e, à medida que se sucediam, a nossa esperança diminuía.",
        "Subitamente, a minha mãe deu um grito.",
        "«Ai, tá ali o nosso Quim!»",
        "«Se calhar não é ele, se calhar não é ele!»",
        "«Aonde, aonde, ai, valha-me Deus!»",
        "Mas, desta vez, era. Magrinho, mas lá estava com aquele sorriso aberto. No preto-e-branco, parecia mais bronzeado. Ao mesmo tempo, havia nele uma palidez que lhe desconhecíamos. Tinha o bivaque da tropa e o camuflado vestido, de mangas arregaçadas. Ao pescoço trazia um fio, com qualquer coisa pendurada, que apertava com uma das mãos.",
        "«Aqui fala o soldado Joaquim Cachopas, para os meus irmãos, mãe e sobrinho...» Nesse instante, sem que o sorriso caísse, pareceu ir desatar a soluçar, mas recompôs-se e ainda disse, antes de ser empurrado por outro: «Feliz Natal e não me esqueço de vocês.»",
        "Durou menos de um minuto esta aparição. Mas era como se uma explosão nos tivesse atingido e os seus fragmentos viessem na nossa direção em câmara lenta, antes de nos entrarem no corpo para, finalmente, ouvirmos o detonar e sentirmos a dor.",
        "«Ai, meu rico mano!», «Ai, meu rico filho! Tão magrinho que ele está.»",
        "E eu, agarrando-lhes a roupa: «Mãe, ele disse o meu nome, não disse? Falou no sobrinho!»",
        "E, como se acabássemos de receber a notícia de uma morte iminente, desatámos todos a chorar. Quim deixara de ser uma memória querida e um conjunto de frases escritas numa carta. Ganhara, de novo, um corpo e voltara a fazer escutar a voz que lhe conhecíamos. Era ele, mas longe do nosso alcance. A morte e a doença como companheiras. Chorámos, sem saber bem porquê. Mesmo se mais tarde nos viemos a sentir gratos por, no meio daqueles milhares de rapazes e homens enviados para a dor, lhe ter calhado a sorte de ser escolhido para falar. E, sobretudo, pelo facto de o seu testemunho não ter sido cortado na edição."
      ]
    }
  },
  "2": {
    title: "A Vida Sonhada das Boas Esposas",
    year: "2019",
    genre_pt: "Romance",
    genre_en: "Novel",
    salesType: "ebook",
    price: "Esgotado",
    price_ebook: "€7.00",
    price_audiobook: "Brevemente",
    format_pt: "Livro Impresso (Esgotado) / E-Book / Audiolivro",
    format_en: "Hardcopy (Sold Out) / E-Book / Audiobook",
    badge_pt: "E-Book",
    badge_en: "E-Book",
    hardcopySoldOut: true,
    cover: resolveAsset("a-vida-sonhada-das-boas-esposas.jpg"),
    cover_digital: resolveAsset("a-vida-sonhada-das-boas-esposas-digital.webp"),
    synopsis_pt: "Um olhar contemporâneo sobre o papel da mulher, a expressão da sua sexualidade e a visão que a família e a sociedade mantêm sobre ela à medida que o tempo passa.",
    synopsis_en: "A contemporary reflection on women's roles, the expression of female sexuality, and the perceptions maintained by family and society over time.",
    links: [
      { name: "FNAC Portugal", desc: "Loja Online & Entrega Rápida", url: "https://www.fnac.pt/A-Vida-Sonhada-das-Boas-Esposas-Possidonio-Cachapa/a7252752?oref=a1385525-ddc4-9ccc-d22b-de47caaa4e1e" },
      { name: "Worten Livros", desc: "Marketplace Editorial Oficial", url: "https://www.worten.pt/produtos/livro-a-vida-sonhada-das-boas-esposas-de-possidonio-cachapa-portugues-capa-dura-mrkean-9789896659097" }
    ],
    excerpt: {
      hasChapterTitle: true,
      chapter_pt: "O Comandante e a Sonhadora",
      chapter_en: "The Commander and the Dreamer",
      hasFadeOut: true,
      paragraphs: [
        "Teresinha M. examinava inquisitivamente a pilha de camarão cozido, enfeitada com rodelas de limão. Preocupava-se com várias coisas. A saber: quantas mãos já tinham tocado naquelas carapaças antes dela, se seriam mesmo frescos e quantos poderia comer sem rebentar com os resultados da dieta de fome que se impusera nos últimos dois meses. Com a pena de quem se despede de um amigo, tirou apenas três, que depositou amorosamente ao lado da salada de alface e manga. A americana atrás de si sorriu satisfeita perante a atitude de frugalidade e, pegando em dois garfos, fez uma pilha gigante no prato. «Oh, faz lembrar o monte Rushmore», pensou, alegremente, antes de se dirigir para a mesa onde o marido de trezentas e trinta libras de peso já se batia com um Grand Canyon de peru entalado no Death Valley das batatas assadas. Duas crianças, mortas de tédio, paridas do mesmo gigantesco odre, olhavam pela janela onde só se via mar. Nos telemóveis na mão rodavam, em loop, guerreiros e unicórnios parados, à espera da ordem de ataque.",
        "Teresinha sentou-se na mesa onde Emília e Madalena comiam.",
        "«Ai, meninas, isto é uma perdição, mas a pessoa não pode provar tudo. Senão, anda-se a fazer dieta para um lado e a engordar para o outro.»",
        "Emília levantou os olhos da perna de porco que tinha no prato, misturada com chop suey de frango, rodelas de tomate, arroz (branco e árabe), duas batatas assadas e umas folhas de alface, parecendo surpreendida.",
        "«Com o que a gente pagou, é mas é comer tudo e mais alguma coisa. Eu, nem que arrebente! Que a minha mãe seja put... seja lá o que ela quiser, coitadinha, que já cá nem está, se eu não encher todos os dias esta barriga até estourar!» Olhou para Madalena, que remexia o caldo de marisco sem levar a colher à boca. «Não acha, Madalena? Se pagámos, é para comermos.»",
        "Madalena pareceu acordar de um lugar distante. Sorriu e levou a colher à boca.",
        "«Sim, a comida é boa.»",
        "A outra pareceu desapontada.",
        "«Boa é dizer pouco. Num restaurante, quanto é que isto não nos custava?! Faz mal em estar só a debicar o prato. Eu cá ainda me vou atirar ao peixe e às sobremesas.»",
        "O restaurante brilhava de dourados, debaixo de um céu artificial, azul-claro, onde as estrelas apareciam mais cedo. Nem deviam ser duas da tarde e já eram milhares a piscar sobre a multidão que enchia o bandulho. As nacionalidades desdobravam-se em volta dos pratos. Madalena reparou na forma como as pessoas pegavam nos talheres. Um homem jovem comia tudo com uma colher, outro, na mesma mesa, usava garfo na esquerda, faca na direita, o chefe da caravana americana dinamitava os seus monumentos com o mesmo esquema, garfo e faca, mas depois trocava o primeiro de mão, despedia-se da faca e comia com a inocência das primeiras carnes.",
        "«Estou curiosa para ver Túnis.»",
        "«Hum, hum», respondeu Emília.",
        "Teresinha, que já tinha acabado o que tinha no prato e sentia a mesma fome, resmungou:"
      ]
    }
  },
  "3": {
    title: "Eu Sou a Árvore",
    year: "2016",
    genre_pt: "Romance",
    genre_en: "Novel",
    salesType: "direct_physical",
    price: "€10.00",
    price_ebook: "Brevemente",
    price_audiobook: "Brevemente",
    format_pt: "Livro Impresso Autografado / E-Book / Audiolivro",
    format_en: "Autographed Hardcopy / E-Book / Audiobook",
    badge_pt: "Autografado",
    badge_en: "Autographed",
    cover: resolveAsset("eu-sou-a-arvore.webp"),
    synopsis_pt: "Entre os homens e as árvores há tanto em comum que por vezes não se sabe onde começam uns e acabam os outros. Samuel acredita que lhe basta um solo fértil para ser feliz e, sendo-o, permitir que todos o sejam tanto como ele. Mas, a família tem outros sonhos...",
    synopsis_en: "There is so much in common between men and trees that sometimes it is hard to tell where one ends and the other begins. Samuel believes fertile soil is all he needs to be happy...",
    links: [
      { name: "FNAC Portugal", desc: "Loja Online & Entrega Rápida", url: "https://www.fnac.pt/Eu-Sou-a-Arvore-Possidonio-Cachapa/a973985" },
      { name: "Worten Livros", desc: "Marketplace Editorial Oficial", url: "https://www.worten.pt/produtos/livro-eu-sou-a-arvore-de-possidonio-cachapa-portugues-mrkean-9789896650995" }
    ],
    excerpt: {
      hasChapterTitle: false,
      paragraphs: [
        "E ele, vendo isso, sentindo isso, só conseguia estender a mão pelo vidro de uma das janelas, como se quisesse de alguma forma esclarecer um equívoco.",
        "Nunca mais ninguém apareceu a saber dele, porque corria o boato de que tinha enlouquecido e que disparava contra quem ali assomasse. Uma ou outra vez, algumas crianças dos montes próximos subiram para cima do portão da quinta, tentando avistar, excitadas, o homem a quem diziam maluco. Mas raramente o viam.",
        "Samuel, sem se dar conta, foi deixando de mudar de roupa ou de cortar a barba. Tomava às vezes um banho no pego que nunca secava, ao fundo da propriedade, e, muito de vez em quando, um duche no interior da casa.",
        "Não estava arruinado, no sentido de dever a alguém ou de já não ter qualquer dinheiro no banco, mas deixara de pagar as contas. Porque não tinha qualquer vontade de sair dali e os detalhes práticos da vida, que antes lhe pareciam coisas de resolução fácil, se haviam avolumado de tal forma que não sabia por onde começar. Assim, um dia, ao anoitecer, deu ao botão do interruptor e a luz não se acendeu.",
        "«Sou um bicho», disse para si, um dia, ao reparar nas unhas compridas e cobertas de terra. «Transformei-me num bicho...», repetiu, na sua cabeça. Mas não fez nada para deixar de o ser.",
        "Pelo contrário, por ser ainda tempo quente, nessa noite dormiu na rua, em cima da erva, e os mosquitos procuraram furar-lhe cada parte de pele exposta. «Sou um bicho», voltou a dizer em sonhos. E assim se manteve, atordoadamente preso ao pesadelo onde se deixara enlear."
      ]
    }
  },
  "4": {
    title: "O Mundo Branco do Rapaz Coelho",
    year: "2009",
    genre_pt: "Romance Distópico",
    genre_en: "Dystopian Novel",
    salesType: "direct_physical",
    price: "€10.00",
    price_ebook: "Brevemente",
    price_audiobook: "Brevemente",
    format_pt: "Livro Impresso Autografado / E-Book / Audiolivro",
    format_en: "Autographed Hardcopy / E-Book / Audiobook",
    badge_pt: "Autografado",
    badge_en: "Autographed",
    cover: resolveAsset("o-mundo-branco-do-rapaz-coelho.jpg"),
    synopsis_pt: "Romance distópico sobre um mundo onde o consumismo e luta pelo poder atraem o gelo e a neve.",
    synopsis_en: "A dystopian novel about a world where consumerism and the struggle for power bring forth ice and snow.",
    links: [],
    excerpt: {
      hasChapterTitle: true,
      chapter_pt: "III — Onde Miss Turtle se exibe. Como sempre",
      chapter_en: "III — Where Miss Turtle Shows Off. As Always",
      paragraphs: [
        "Está quente, pensou o Rapaz-Coelho.",
        "Ajeitou os boxers de riscas e apontou, sem convicção, o telecomando para a televisão. O ruído da estática voltou a encher o espaço. Carregou noutra tecla e uma seta verde foi diminuindo de tamanho até que os pontos pretos e brancos se tornaram numa intermitência silenciosa. Batiam contra o ecrã, aos milhares, mas mudos, presos. Nada de novo.",
        "O Rapaz-Coelho pensou ainda: Tenho fome.",
        "Mas não se levantou logo. Ficou ainda ali um bocado, uma das orelhas cor-de-rosa dobrada debaixo da cabeça. O cabelo escuro, cada vez maior, saía pela frente, e até mesmo por baixo, no sítio em que ele prendia as orelhas com um botão de mola.",
        "Desligou a televisão e caminhou, apenas de meias, até à cozinha, abriu o frigorífico e reflectiu sobre qual dos pacotes abriria nesse momento. Com este tempo de Verão eterno, só me apetece coisas frescas.",
        "Retirou uma embalagem de massa com camarões e ananás, decorada com desenhos de ondas e palmeiras. Mas acabou por avistar outra, de gelatina multicor e cápsulas refrescantes. «Vou antes para isto», disse. «A fome é pouca. Se quiser mais, é só voltar aqui.»",
        "Voltou para a sala, consolado pela abundância e empurrou com o pé umas revistas manga. Falavam de Mitsuko, o herói jovem que vencia todos os seus inimigos sem precisar sequer de pôr um pé fora do prédio de mil andares onde vivia. Sentou-se de novo em frente ao ecrã de televisão a comer a gelatina. Não pensava em nada, limitava-se a comer e a olhar em frente. Os pontos pretos, os pontos brancos.",
        "«Olá», disse do lado de fora da janela uma voz.",
        "O Rapaz-Coelho sorriu, atirou com a embalagem para o chão e foi espreitar.",
        "«Ei, Miss Turtle, já estava farto de estar sozinho. É hoje que vamos curtir, ou quê?»",
        "A rapariga japonesa, vestida com uma saia curtíssima e uma camisa branca aberta que lhe deixava ver uns seios invulgarmente desenvolvidos, soltou um risinho.",
        "«Ainda não, coelhinho. És muito giro, mas tenho medo que me faças doer.»",
        "Esta frase excitou o Rapaz-Coelho que sentiu o princípio de uma erecção empurrar-lhe os boxers.",
        "«Sou até muito delicado», disse. Poderia ter acrescentado que esperava que ela própria fosse cuidadosa com ele, que nunca tinha feito, fisicamente, claro, nada daquilo que lhe estava sempre a propor.",
        "A rapariga japonesa deu mais uma pequena gargalhada e tocou, como que por acaso, no lugar exacto onde se terminava a exposição das longas pernas. Gritou como se estivesse muito contente: «Hoje não posso, tenho de ir entregar uma coisa. Adeus!»",
        "Virou-se muito depressa e, nesse movimento, a saia levantou e o Rapaz-Coelho pôde avistar a roupa interior pinky, com desenhos irregulares de caras de rapariga-manga, sorridentes e convidativas. Viu-a afastar-se pelo meio do jardim, tocar uma última vez numa árvore cheia de frutos maduros e desaparecer na direcção do Sol.",
        "O Rapaz-Coelho voltou para o seu lugar, apanhou do chão a embalagem de gelatina e comeu o resto. No volume dos boxers, uma mancha húmida. Oh, Miss Turtle..."
      ]
    }
  },
  "5": {
    title: "O Meu Querido Titanic",
    year: "2005",
    genre_pt: "Crónicas",
    genre_en: "Chronicles",
    salesType: "coming_soon",
    price: "Brevemente",
    price_ebook: "Brevemente",
    price_audiobook: "Brevemente",
    format_pt: "Livro Impresso Autografado / E-Book / Audiolivro",
    format_en: "Autographed Hardcopy / E-Book / Audiobook",
    badge_pt: "Brevemente",
    badge_en: "Coming Soon",
    cover: resolveAsset("o-meu-querido-titanic.jpg"),
    synopsis_pt: "Livro de crónicas ora doces ora sarcásticas que deixam o país a nu. E que tem pena de o fazer.",
    synopsis_en: "A collection of sweet yet sarcastic chronicles exposing the country with a touch of tender pity.",
    links: [],
    excerpt: {
      hasChapterTitle: true,
      chapter_pt: "Chaparros",
      chapter_en: "Chaparros",
      paragraphs: [
        "Fui, no outro dia, divorciar-me, ao Alentejo. É sempre de bom grado que me meto à estrada e percorro os 150 quilómetros que me separam daquela zona tão amiga dos sobreiros. A auto-estrada está boa: ainda não tem o piso destruído, são raras as obras de melhoramento e o trânsito não era ainda de férias. Vários euros depois, lá estava eu a fazer-me à via, por assim dizer, rápida, onde o juiz, se Deus quisesse, me aguardava. Quando me começaram a aparecer os chaparros respirei fundo: a cidade grande estava a ficar para trás. A certa altura era uma beleza: chaparros ao lado da estrada, chaparros ao volante, chaparros à minha espera com os processos na mão... Era Portugal no seu melhor.",
        "Não sei se toda a gente que me está a ler já se divorciou... Se ainda não, aconselho vivamente. Que mais não seja para conviverem com as alegrias do sistema. A coisa não pode ser mais simples...",
        "Primeiro, tem de se ter um casamento desfeito. Uma coisa que não dê mais; enfim, sentirmo-nos miseráveis e culpados ou abandonados. Depois, é só procurar um advogado, que, por 500 euros (se for simpático), vos inicia na arte.",
        "«Por mútuo consentimento?!», alegrou-se o meu.",
        "«Então, não vai ter complicações nenhumas...» E ia tendo razão.",
        "Preenchemos a papelada, sem olhar para lá, porque os nossos nomes estavam escarrapachados ao lado da nossa tristeza, esmiuçámos a distribuição dos nossos parcos bens, a partilha dos filhos e pronto. Estávamos prontos para o arranque. Tudo preto no branco no papel.",
        "Suspirámos de alívio. Estava concluído! O que valeu foi o advogado, que me olhou condescendente e me informou de que agora teria de ir ao tribunal dizer, perante o juiz, que o que tínhamos assinado era mesmo o que queríamos. Pareceu-me bem. Há muitas pessoas analfabetas ou distraídas que assinam qualquer coisa e depois arranjam chatices. Felizmente, o nosso irmão mais velho (Big Brother) pensou por nós. E assim lá fui eu, a primeira vez, fazer os 150 quilómetros que me separavam do tribunal.",
        "Devo dizer que se não correu melhor a culpa há-de ter sido toda minha, que não apreciei o tempo que estivemos à espera de ser atendidos, nem os quase 60 segundos que durou a «conferência» em que um juiz com o ar mais arrogante que o Luís XVI me interrogou sobre os meus deveres paternais. Posso alegar que para um pai-galinha, como eu, estas acusações semiveladas e sem ponta de fundamento me soavam insultuosas. Mas quem era eu para me sentir insultado por alguém que usava o cognome de O Meritíssimo. Nunca percebi bem quem o indigitou, mas penso que foi Deus... Digo eu... pelo ar dele. Confidenciou-me o meu advogado que este é dos mais rápidos daquele tribunal. Parece que os antepassados já eram juízes e que a coisa lhe corria no sangue. Isto deu-me a ideia de propor ao Ministério da Justiça que nomeie atletas de alta competição reformados para os tribunais. Já estou a ver um tribunal do Porto à cunha e ser anunciado:",
        "«A Meritíssima Sra. Dra. Rosa Mota vai despachar a correr este caso de corrupção na Bolsa.» Julgo que a palavra «despacho» adquiriria aqui o seu real valor. Enfim...",
        "Façamos o ponto da situação: o casal já decidiu entre si que não quer continuar; já colocaram por escrito a sua vontade, a distribuição dos bens e a regulação do poder paternal; já reafirmaram a sua vontade perante um juiz...",
        "Devia estar terminado... Engano: estamos a meio do processo.",
        "«Voltamos cá daqui a três meses», anunciou-me, no seu desprendimento corajoso, o advogado. «Para quê?», perguntei, ingénuo. «Ora, para voltar a dizer a mesma coisa!» Agora já só tínhamos que voltar a preencher os papéis a dizer o mesmo que tínhamos dito antes e voltar ao mesmo juiz para confirmar…"
      ]
    }
  },
  "6": {
    title: "O Mar por Cima",
    year: "2002",
    genre_pt: "Romance",
    genre_en: "Novel",
    salesType: "direct_physical",
    price: "€10.00",
    price_ebook: "Brevemente",
    price_audiobook: "Brevemente",
    format_pt: "Livro Impresso Autografado / E-Book / Audiolivro",
    format_en: "Autographed Hardcopy / E-Book / Audiobook",
    badge_pt: "Autografado",
    badge_en: "Autographed",
    cover: resolveAsset("o-mar-por-cima.jpg?v=3"),
    synopsis_pt: "Romance de uma intensidade feroz, capaz de abalar a nossa visão do mundo, das pessoas e do amor. Narrativa crua mas simultaneamente pura, uma vertigem.",
    synopsis_en: "A novel of fierce intensity, capable of shaking our vision of the world, people, and love. A raw yet pure, vertiginous narrative.",
    links: [],
    excerpt: {
      hasChapterTitle: false,
      paragraphs: [
        "A bordo da lancha, as pessoas iam caladas. De uma maneira ou de outra. O nome, Capitão das Ilhas, mergulhava na escuma, uma e outra vez, mesmo se o céu se apresentava sem grandes nuvens ou coisas de preocupar. Via-se as letras a molharem-se, uma a uma, até o nome ficar submerso quase até à parte superior; ali, onde o til reinava, ao lado do i maiúsculo das ilhas. Um homem pálido, com a barba por fazer, seguia à proa. A ressalva vinha ao seu encontro sempre que a quilha se esforçava em direcção ao céu. Mas ele continuava seguro, o rosto virado para a ilha da frente.",
        "Lá dentro, seguia uma mulher. Ia abrigada. Guardava o que tinha de guardar, com uma mão por cima. Uma mão pálida, como que fria, onde os veios se destacavam verdes e mais antigos do que ela um dia teria desejado para si. Agora já não.",
        "Uma criança, com pouco mais que idade de colo, aborrecia-se sem perceber porque se sentia enjoada, porque estava tudo em silêncio, porque o céu subia e descia pelas janelas laterais. Puxou a roupa à avó, que a acompanhava. Queria brincar. Mas esta aconchegou-a a si, ajeitou-lhe os cabelos displicentemente cortados pela tesoura de costura e abanou a cabeça, num sinal de que tivesse paciência, que não tardariam a chegar.",
        "Havia mais alguns passageiros no Capitão das Ilhas, naquele dia. Preferiam remeter-se em grupo para a popa, fumando cigarros fortes a que davam o esperançoso nome de «Além do Mar».",
        "Visto por cima, o barco era um rectângulo aguçado a riscar, a branco, a sua redundante rota. E pássaros e peixes desviavam-se para o lado, como se abrissem caminho ou participassem na criação de um deserto igual ao que lhe ia pelo cavername dentro."
      ]
    }
  },
  "7": {
    title: "Viagem ao Coração dos Pássaros",
    year: "1999 / 2015",
    genre_pt: "Romance",
    genre_en: "Novel",
    salesType: "coming_soon",
    price: "Brevemente",
    price_ebook: "Brevemente",
    price_audiobook: "Brevemente",
    format_pt: "Livro Impresso Autografado / E-Book / Audiolivro",
    format_en: "Autographed Hardcopy / E-Book / Audiobook",
    badge_pt: "Brevemente",
    badge_en: "Coming Soon",
    cover: resolveAsset("viagem-ao-coracao-dos-passaros.webp"),
    synopsis_pt: "Através da viagem interior de Kika, a que tudo vê; esta obra explora o tempo e o desejo humano, onde contrastes e contradições moldam as vidas das personagens — simbolicamente entrelaçadas com a natureza.",
    synopsis_en: "Through the inner journey of Kika, the all-seeing; this work explores time and human desire, where contrasts and contradictions shape the characters' lives—symbolically intertwined with nature.",
    links: [],
    excerpt: {
      hasChapterTitle: true,
      chapter_pt: "Almoçaram Sobre as Barricas",
      chapter_en: "They Had Lunch on the Barrels",
      paragraphs: [
        "Durante os anos que o marido estivera fora, procurou Evangelina não pôr os olhos nos homens nem ligar aos calores fantasiosos que lhe atormentavam as noites. Baixava as pálpebras à saída da missa e não dava cavaco a nenhum que subisse o carreiro que passava em frente à casa. De quem tinha ela medo? Deles ou de si? Era por certo dos dois; de perder os olhos num peito glabro e de imaginar os seus dedos a tocarem aquela macieza toda; de ver um rabo mais firme asfixiado nas calças de fazenda preta de ir à missa e sonhar que as suas unhas poderiam ali deixar marca, quando ele se contraísse no seu vaivém orgástico... Tudo isto ela temia, mas o seu maior receio era esquecer o rosto daquele a quem se julgava ligada para sempre. Perder de vista o seu homem; substituí-lo nos sonhos por outro que só tivesse um corpo fugaz para lhe dar.",
        "Tomou por inimigas as mãos; peças viciosas de um mal superior e imprevisível, que todas as noites (mesmo aquelas em que Kika adormecia, celeste, a seu lado) a atormentavam com propostas de jogos e brincadeiras indecentes. Mal ela se distraía e já os dedos à queima-roupa lhe levantavam a camisa de dormir, perdendo-se nas redondezas da cidade proibida e pedindo aos portões de ferro que os deixassem entrar, para que se passeassem em silêncio pelos corredores desertos.",
        "Quando isto contou a medo ao padre, ele suspirou, como se já esperasse a confissão, pois é certo que o poder de pecar das mulheres é imenso, basta atentar na Eva, que até com as cobras se aliou... Se bem que, aí, o padre se interrogasse se a primeira das mulheres seria mais estúpida (coisa científica e eclesiasticamente comprovada pela incapacidade feminina em superintender o sacerdócio!) ou porventura..."
      ]
    }
  },
  "8": {
    title: "Materna Doçura",
    year: "1998 / 2004 / 2015",
    genre_pt: "Romance (Obra Emblemática)",
    genre_en: "Acclaimed Novel",
    salesType: "direct_physical",
    price: "€10.00",
    price_ebook: "Brevemente",
    price_audiobook: "Brevemente",
    format_pt: "Livro Impresso Autografado / E-Book / Audiolivro",
    format_en: "Autographed Hardcopy / E-Book / Audiobook",
    badge_pt: "Autografado",
    badge_en: "Autographed",
    cover: resolveAsset("materna-docura.jpg"),
    synopsis_pt: "Uma história de perda e identidade, Sacha, uma criança órfã de mãe embarca numa jornada emocional para (re)encontrar o amor e compreender as marcas da ausência. Traduzido em várias línguas e aclamado pela crítica europeia.",
    synopsis_en: "A story of loss and identity, Sacha, a young motherless child, embarks on an emotional journey to rediscover love and make sense of absence. Translated into multiple languages and acclaimed across Europe.",
    links: [],
    excerpt: {
      hasChapterTitle: false,
      paragraphs: [
        "Já ia avançado na posta de pargo grelhado, quando os viu entrar. Reparou primeiro na bela mulher de vestido escavado em flores. Seguiu-se-lhe o homem. Muito velho para ela, pensou. Mas só quando viu chegar Sacha, afobado no seu atraso, é que percebeu estar frente à família do rapaz.",
        "Sacha trazia uma pequena câmara de filmar. Uma Super-8. Com um gesto de mão, pediu à mãe que parasse à entrada. Depois accionou a câmara e fez-lhe sinal, como se dissesse «Acção». A mãe, sorridente, avançou e fez um gesto quase pueril de aceno. Impaciente, o cineasta empurrou-os para uma mesa afastada.",
        "O miúdo não o vira, por isso o Professor agachou-se um pouco mais, atrás das flores que decoravam a toalha, observando o grupo.",
        "A mulher era, de facto, muito bonita. Os mesmos cabelos do filho, mas as formas longas e generosas. O Professor reparou como o velho lhe roçava a mão pela macieza do braço. E desejou estar no lugar dele.",
        "Sacha comia calado, os olhos no prato. Ou do prato para a mãe.",
        "Viu-o fazer várias tentativas para entrar na conversa dos adultos. Depois, como ninguém lhe ligasse, começou a brincar com o copo da água. E, quando nem um nem outro o observavam, deixou-o cair ao chão, onde se estilhaçou com espalhafato.",
        "— Oh, Sacha — ouviu o Professor proferir à mãe.",
        "O cineasta levantou a mão para lhe aplicar um tabefe. Mas já a garra da leoa se levantava a aparar o gesto e os seus olhos faiscantes a amedrontarem o homem. O Professor não percebeu o que eles diziam, mas viu o sorriso contrariado do homem e a sua mão a dizer que, afinal, não tinha importância. Sacha ganhara a partida.",
        "Ficou ali mais um bocado, até que lhe começaram a doer as costas e se levantou. Ao dirigir-se para a porta, viu que Sacha lhe acenava.",
        "— Boa noite. — Cumprimentou o grupo, sem se deter.",
        "A mulher mirou-o, curiosa. O filho já lhe devia ter falado dele. Observou-o de alto a baixo, num relance. Os olhos escuros a penetrarem-lhe no corpo; a medirem os prós e os contras do convívio com o rebento. Mas, no fundo de tanta argúcia materna, divisou o Professor uma luzinha ingénua que se agigantou num relance como um calcanhar de Aquiles cravado nas flores. Finalmente, ela fez-lhe um cumprimento de cabeça, de uma elegância em auto-aprendizagem.",
        "Quanto ao candidato a padrasto, mal levantou os olhos, ocupado como estava a chupar a enorme espinha de um besugo.",
        "— É linda, mãe, é linda.",
        "E Gracinha passava-lhe a mão macia pelo ombro doce. E depois puxava-o ao seio, onde Sacha mergulhava, os sentidos acordados e as delícias — mil — a correrem-lhe, desconhecidas, o corpo.",
        "A Lua a brilhar lá fora e o quarto a flutuar num perfume de flores brancas e perigosas. Sacha viu o seu peito a descoberto, e a boca da mãe, que lho cobria de beijos.",
        "— É linda, mãe, é linda — repetiu.",
        "E a mãe voltou a sorrir-lhe e a deixar a manga do négligé roçar-lhe a face de seda. O dedo altivo a cerrar-lhe a boca num silêncio comprometido e cúmplice, num misterioso segredo que só aos dois pertencia."
      ]
    }
  },
  "9": {
    title: "Nylon da Minha Aldeia",
    year: "1997 / 2025 (Nova Edição)",
    genre_pt: "Novela / Adaptado ao Cinema",
    genre_en: "Novella / Cinema Adaptation",
    salesType: "direct_both",
    price: "€10.00",
    price_ebook: "€7.00",
    format_pt: "Livro Impresso Autografado / E-Book",
    format_en: "Autographed Hardcopy / E-Book",
    badge_pt: "Autografado",
    badge_en: "Autographed",
    cover: resolveAsset("nylon-da-minha-aldeia.png"),
    cover_digital: resolveAsset("nylon-da-minha-aldeia-digital.webp"),
    synopsis_pt: "Uma narrativa intensa centrada na vida e nas transformações de uma comunidade rural, num estilo que combina memória afetiva e crítica social, marcada por relações humanas e percursos individuais. Adaptada ao cinema em 2012. Nova edição em 2025.",
    synopsis_en: "An intense narrative centered on the life and transformations of a rural community, combining emotional memory and social critique, marked by human relationships and individual paths. Adapted into cinema in 2012. New edition in 2025.",
    links: [],
    excerpt: {
      hasChapterTitle: true,
      chapter_pt: "Encontrei-te Neste Lugar Tranquilo",
      chapter_en: "I Found You in This Peaceful Place",
      paragraphs: [
        "Marcelo tinha umas mãos de místico. Quando estava sozinho deixava-as elevarem-se no ar e os dedos formavam pássaros e flores. Um cheiro a rosmaninho parecia nascer destes gestos e Serginho, na sua primeira juventude, costumava mirar estas mãos, fascinado. Como se um encantamento se desprendesse destes bailados de imaginação.",
        "Mas desde que o opróbrio o cobrira que Marcelo calara as mãos. Em público, por pudor. E, em privado, porque as mãos eram o seu símbolo de felicidade e essa tinha-se desvanecido numa frase junto à ribeira.",
        "Mas, também a ele, os sonhos desobedeceram. E as mãos levantaram-se de novo, pedindo-lhe coreografias ousadas e poéticas.",
        "Quando sonhava, Marcelo via as mãos como jardins floridos onde passeavam figuras de branco, cobertas de lírios claros.",
        "Acordava, aflito da sua fraqueza e, ali mesmo, as repreendia. Depois, levantava-se, porque o sono partira à desfilada e passeava pela casa até o dia nascer.",
        "Outras vezes, vestia-se e saía à rua, temendo encontrar alguém; alguém que lhe envenenasse o ar noturno.",
        "Uma noite, os seus passos encaminharam-no para a ribeira. Buscava o barulho da água e, sem saber, a lembrança do seu amor, para sempre perdido. Deitou-se entre os juncos, sem medo ao escuro nem aos bichos do mato.",
        "Ouviu, de repente, uns passos descalços. Um andar de gamo por entre as ervas. E um vulto fino e branco encheu a noite com os seus longos cabelos caídos em cascata sobre os ombros.",
        "Arrepiaram-se-lhe os cabelos, mais pela surpresa que pelo medo das almas penadas. Mas, ao vê-la triste e debruçada sobre as águas, reconheceu nela um semelhante. Alguém que tinha um sofrimento maior do que o corpo, e que ali o vinha afogar, a coberto da noite.",
        "Foi então que lhe ouviu a voz. O cântico elevou-se no negro do céu. Lourdinhas lançava o seu chamamento. Marcelo ouviu-a, atento. Não lhe espantou a pureza da voz, porque das criaturas fantásticas tudo se espera; mesmo numa aldeia perdida; mesmo àquelas horas da madrugada.",
        "Escutou-lhe as palavras estranhas durante muito tempo.",
        "Até que ela se calou e, como se o espetáculo tivesse terminado, se levantou em silêncio, caminhando na sua direção. Ele escondeu-se entre os arbustos para não perturbar aquela que caminhava assim. Só então reparou que as suas mãos se tinham elevado durante o recital, acordadas pelo noturno inesperado.",
        "Voltou na noite seguinte, mas ela não apareceu. Não sabia que o marido lhe tinha batido, ao vê-la entrar fora de horas. E que por isso ela tinha ficado acordada temendo repetir a fuga.",
        "À segunda vez, porém, foi mais bem-sucedido e o vulto branco cantou para o céu uma melodia de amor. Marcelo corria os olhos da voz para o branco da camisa e do nylon para a seda daquela música. Desta vez não se escondeu, mas ela passou sem o ver.",
        "«O seu reino não é deste mundo», pensou.",
        "E não se enganava, porque o mundo dos sonhos não nos pertence e, só ali, Lourdinhas era verdadeiramente livre.",
        "Pouco a pouco, foi-se aproximando, até que nos traços da deusa reconheceu a figura desprezada da mulher do Zé Pinguinhas. Mas isto, em vez de lhe diminuir o encanto, aumentou-lho, porque dava à mulher uma auréola de coragem que ninguém lhe suporia."
      ]
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  initHeroParallax();
  initTimelineAccordion();
  initTimelineInteractions();
  init3DHardcoverBook();
  initNovidadesBooks();
  initRecommenderWizard();
  initBookFiltering();
  initHoloCoverMorphEngine();
  initBookModalControls();
  initDrawerToggles();
  initLanguageToggle();
  initMobileMenu();
  initAmbientAudioEngine();
  initPhysicsPressCarousel();
  initExcerptReader();
  initCrossPageAnchorNavigation();

  if (typeof window !== 'undefined') {
    window.openBookDetailModal = openBookDetailModal;
    window.openExcerptReader = openExcerptReader;
    window.openOrderDrawerForBook = openOrderDrawerForBook;
    window.closeAllDrawers = closeAllDrawers;
  }
});

/**
 * FEATURE #1: Multi-Layered Breakout 3D Parallax Mouse Tracking Engine
 */
function initHeroParallax() {
  const stage = document.getElementById('heroParallaxStage');
  const bgImg = document.getElementById('heroCardBgImg');

  if (!stage || !bgImg) return;

  let animationFrameId = null;

  stage.addEventListener('mousemove', (e) => {
    const rect = stage.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const deltaX = (x - centerX) / centerX; // -1 to 1
    const deltaY = (y - centerY) / centerY; // -1 to 1

    if (animationFrameId) cancelAnimationFrame(animationFrameId);

    animationFrameId = requestAnimationFrame(() => {
      // Ultra-subtle, smooth inner image panning inside the fixed card frame & cutout
      const moveX = deltaX * -5;
      const moveY = deltaY * -4;
      bgImg.style.transform = `scale(1.22) translate(${moveX}px, ${moveY}px)`;
    });
  });

  stage.addEventListener('mouseleave', () => {
    if (animationFrameId) cancelAnimationFrame(animationFrameId);
    bgImg.style.transform = `scale(1.22) translate(0px, 0px)`;
  });
}

/**
 * FEATURE #4: Cross-Browser Time-Delta (dt) Synchronized Physics Press Carousel Engine ("Wiii Run!")
 */
function initPhysicsPressCarousel() {
  const viewport = document.getElementById('pressViewport');
  const track = document.getElementById('pressTrack');

  if (!viewport || !track) return;

  let position = 0;
  // Speed normalized to Pixels Per Second (26.4 px/sec = 0.44px/frame at 60fps)
  const baseSpeedPxPerSec = -26.4; 
  let currentBaseSpeed = -26.4;
  let velocity = 0;
  let isDragging = false;
  let startX = 0;
  let startPos = 0;
  let lastX = 0;
  let lastTime = 0;
  let lastFrameTime = performance.now();
  let isHovered = false;
  let dragDistance = 0;

  function getHalfWidth() {
    return track.scrollWidth / 2;
  }

  // Delta-Time (dt) Animation Loop for 100% Identical Speed Across All Devices & Display Refresh Rates
  function animate(now) {
    const dt = Math.min((now - lastFrameTime) / 1000, 0.1); // Convert ms to seconds
    lastFrameTime = now;

    const halfWidth = getHalfWidth();

    // Smooth lerp deceleration when hovering for natural stop
    const targetBaseSpeed = isHovered ? 0 : baseSpeedPxPerSec;
    currentBaseSpeed += (targetBaseSpeed - currentBaseSpeed) * (1 - Math.exp(-10 * dt));

    if (!isDragging) {
      // Exponential decay friction frame-rate independent
      velocity *= Math.exp(-5 * dt);

      if (Math.abs(velocity) < 1) velocity = 0;

      const speed = currentBaseSpeed + velocity;
      position += speed * dt;
    }

    if (position <= -halfWidth) {
      position += halfWidth;
    } else if (position > 0) {
      position -= halfWidth;
    }

    track.style.transform = `translate3d(${position}px, 0, 0)`;
    requestAnimationFrame(animate);
  }

  requestAnimationFrame(animate);

  viewport.addEventListener('mouseenter', () => { isHovered = true; });
  viewport.addEventListener('mouseleave', () => { isHovered = false; isDragging = false; });

  function onPointerDown(e) {
    isDragging = true;
    dragDistance = 0;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    startX = clientX;
    startPos = position;
    lastX = clientX;
    lastTime = performance.now();
    velocity = 0;
  }

  function onPointerMove(e) {
    if (!isDragging) return;

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const currentTime = performance.now();
    const deltaX = clientX - startX;
    dragDistance = Math.abs(deltaX);
    position = startPos + deltaX;

    const dt = (currentTime - lastTime) / 1000;
    if (dt > 0) {
      const dx = clientX - lastX;
      velocity = (dx / dt);
    }

    lastX = clientX;
    lastTime = currentTime;
  }

  function onPointerUp() {
    isDragging = false;
  }

  viewport.addEventListener('mousedown', onPointerDown);
  window.addEventListener('mousemove', onPointerMove);
  window.addEventListener('mouseup', onPointerUp);

  viewport.addEventListener('touchstart', onPointerDown, { passive: true });
  window.addEventListener('touchmove', onPointerMove, { passive: true });
  window.addEventListener('touchend', onPointerUp);

  viewport.addEventListener('wheel', (e) => {
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
      e.preventDefault();
      velocity += -e.deltaX * 6;
    }
  }, { passive: false });

  // Handle Clicking Press Cards to View Book Detail or Media Kit
  const pressCards = track.querySelectorAll('.press-card-item');
  pressCards.forEach(card => {
    card.addEventListener('click', (e) => {
      if (dragDistance > 6) return;
      if (card.hasAttribute('data-open-mediakit')) return;

      const bookId = card.getAttribute('data-book-id');
      if (bookId) {
        openBookDetailModal(bookId);
      }
    });
  });
}

/**
 * Bio / Timeline Accordion Reveal Engine
 */
function initTimelineAccordion() {
  const dividerBtn = document.querySelector('.bio-divider-btn');
  const navBioLink = document.getElementById('navBioLink');
  const timelineSection = document.getElementById('linha-do-tempo');
  
  if (!timelineSection) return;

  function getExpandedText() {
    return (currentLang === 'en') ? '✦ HIDE BIOGRAPHY ▲' : '✦ OCULTAR BIOGRAFIA ▲';
  }

  function getCollapsedText() {
    return (currentLang === 'en') ? '✦ BIOGRAPHY & TIMELINE ▼' : '✦ BIOGRAFIA & CRONOLOGIA ▼';
  }

  if (dividerBtn) {
    dividerBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const isExpanded = timelineSection.classList.contains('expanded');

      if (isExpanded) {
        timelineSection.classList.remove('expanded');
        dividerBtn.innerHTML = getCollapsedText();
      } else {
        timelineSection.classList.add('expanded');
        dividerBtn.innerHTML = getExpandedText();

        setTimeout(() => {
          timelineSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 150);
      }
    });
  }

  if (navBioLink) {
    navBioLink.addEventListener('click', (e) => {
      e.preventDefault();
      if (!timelineSection.classList.contains('expanded')) {
        timelineSection.classList.add('expanded');
        if (dividerBtn) dividerBtn.innerHTML = getExpandedText();
      }
      setTimeout(() => {
        timelineSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 150);
    });
  }

  // Auto-expand timeline if landing directly with #linha-do-tempo in URL (e.g. from /cart page)
  if (window.location.hash === '#linha-do-tempo') {
    if (!timelineSection.classList.contains('expanded')) {
      timelineSection.classList.add('expanded');
      if (dividerBtn) dividerBtn.innerHTML = getExpandedText();
    }
    setTimeout(() => {
      timelineSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 350);
  }

  window.addEventListener('hashchange', () => {
    if (window.location.hash === '#linha-do-tempo' && !timelineSection.classList.contains('expanded')) {
      timelineSection.classList.add('expanded');
      if (dividerBtn) dividerBtn.innerHTML = getExpandedText();
      setTimeout(() => {
        timelineSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 150);
    }
  });
}

/**
 * FEATURE #2: Interactive 3D Hardcover Book Flip Engine
 */
function init3DHardcoverBook() {
  const scene = document.getElementById('bookScene');
  const bookObject = document.getElementById('hardcoverBookObj');
  const floatingTooltip = document.getElementById('bookFloatingTooltip');

  if (!bookObject || !scene) return;

  let animationFrameId = null;

  function getTooltipText() {
    return (currentLang === 'en') ? 'Click to open' : 'Clique para abrir';
  }

  // Smooth GPU-Accelerated Floating Cursor Tooltip & 3D Tilt
  scene.addEventListener('mousemove', (e) => {
    const isOpen = bookObject.classList.contains('open');

    if (isOpen) {
      if (floatingTooltip) floatingTooltip.style.opacity = '0';
      return;
    }

    const mouseX = e.clientX;
    const mouseY = e.clientY;

    if (animationFrameId) cancelAnimationFrame(animationFrameId);

    animationFrameId = requestAnimationFrame(() => {
      if (floatingTooltip) {
        floatingTooltip.style.transform = `translate3d(${mouseX + 16}px, ${mouseY + 16}px, 0)`;
        floatingTooltip.style.opacity = '1';
      }

      const rect = scene.getBoundingClientRect();
      const x = mouseX - rect.left;
      const y = mouseY - rect.top;
      
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      
      const rotateX = ((y - centerY) / centerY) * -12;
      const rotateY = ((x - centerX) / centerX) * 12;

      bookObject.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.02)`;
    });
  });

  scene.addEventListener('mouseenter', () => {
    const isOpen = bookObject.classList.contains('open');
    if (floatingTooltip) {
      if (isOpen) {
        floatingTooltip.style.opacity = '0';
      } else {
        floatingTooltip.textContent = getTooltipText();
        floatingTooltip.style.opacity = '1';
      }
    }
  });

  scene.addEventListener('mouseleave', () => {
    if (animationFrameId) cancelAnimationFrame(animationFrameId);
    if (floatingTooltip) {
      floatingTooltip.style.opacity = '0';
    }
    if (!bookObject.classList.contains('open')) {
      bookObject.style.transform = `rotateX(0deg) rotateY(-10deg) scale(1)`;
    }
  });

  // Toggle Open / Close Page Flip Animation
  function toggleBookOpen(e) {
    if (e.target.closest('[data-open-excerpt]')) return;

    const isOpen = bookObject.classList.contains('open');
    if (isOpen) {
      bookObject.classList.remove('open');
      bookObject.style.transform = `rotateX(0deg) rotateY(-10deg) scale(1)`;
      if (floatingTooltip) {
        floatingTooltip.textContent = getTooltipText();
        floatingTooltip.style.opacity = '1';
      }
    } else {
      bookObject.classList.add('open');
      bookObject.style.transform = `rotateX(0deg) rotateY(15deg) scale(1.05)`;
      if (floatingTooltip) {
        floatingTooltip.style.opacity = '0';
      }
    }
  }

  bookObject.addEventListener('click', toggleBookOpen);
}

/**
 * FEATURE #6: Dual 3D Book Showcase in "Novidades" Section
 * Handles 3D mousemove tilt tracking on resting perspective angles:
 * - Left Book: default rotateY(16deg)
 * - Right Book: default rotateY(-16deg)
 * Handles click-to-flip open / close for both books independently.
 */
function initNovidadesBooks() {
  const floatingTooltip = document.getElementById('bookFloatingTooltip');

  function getTooltipText() {
    return (currentLang === 'en') ? 'Click to open' : 'Clique para abrir';
  }

  const booksConfig = [
    {
      sceneId: 'novidadesSceneLeft',
      bookId: 'novidadesBookLeft',
      baseRotateY: 16,
      openRotateY: 6,
      baseRotateX: 2
    },
    {
      sceneId: 'novidadesSceneRight',
      bookId: 'novidadesBookRight',
      baseRotateY: -16,
      openRotateY: -6,
      baseRotateX: 2
    }
  ];

  booksConfig.forEach(cfg => {
    const scene = document.getElementById(cfg.sceneId);
    const book = document.getElementById(cfg.bookId);
    if (!scene || !book) return;

    let animFrame = null;

    scene.addEventListener('mousemove', (e) => {
      const isOpen = book.classList.contains('open');
      if (isOpen) {
        if (floatingTooltip) floatingTooltip.style.opacity = '0';
        return;
      }

      const mouseX = e.clientX;
      const mouseY = e.clientY;

      if (animFrame) cancelAnimationFrame(animFrame);

      animFrame = requestAnimationFrame(() => {
        if (floatingTooltip) {
          floatingTooltip.style.transform = `translate3d(${mouseX + 16}px, ${mouseY + 16}px, 0)`;
          floatingTooltip.style.opacity = '1';
        }

        const rect = scene.getBoundingClientRect();
        const x = mouseX - rect.left;
        const y = mouseY - rect.top;

        const centerX = rect.width / 2;
        const centerY = rect.height / 2;

        const tiltX = cfg.baseRotateX + ((y - centerY) / centerY) * -10;
        const tiltY = cfg.baseRotateY + ((x - centerX) / centerX) * 10;

        book.style.transform = `rotateX(${tiltX}deg) rotateY(${tiltY}deg) scale(1.02)`;
      });
    });

    scene.addEventListener('mouseenter', () => {
      const isOpen = book.classList.contains('open');
      if (floatingTooltip) {
        if (isOpen) {
          floatingTooltip.style.opacity = '0';
        } else {
          floatingTooltip.textContent = getTooltipText();
          floatingTooltip.style.opacity = '1';
        }
      }
    });

    scene.addEventListener('mouseleave', () => {
      if (animFrame) cancelAnimationFrame(animFrame);
      if (floatingTooltip) {
        floatingTooltip.style.opacity = '0';
      }
      if (!book.classList.contains('open')) {
        book.style.transform = `rotateX(${cfg.baseRotateX}deg) rotateY(${cfg.baseRotateY}deg) scale(1)`;
      }
    });

    // Toggle Flip Open / Close
    book.addEventListener('click', (e) => {
      if (e.target.closest('[data-open-excerpt]') || e.target.closest('[data-open-order]')) return;

      const isOpen = book.classList.contains('open');
      if (isOpen) {
        book.classList.remove('open');
        book.style.transform = `rotateX(${cfg.baseRotateX}deg) rotateY(${cfg.baseRotateY}deg) scale(1)`;
        if (floatingTooltip) {
          floatingTooltip.textContent = getTooltipText();
          floatingTooltip.style.opacity = '1';
        }
      } else {
        book.classList.add('open');
        book.style.transform = `rotateX(0deg) rotateY(${cfg.openRotateY}deg) scale(1.04)`;
        if (floatingTooltip) {
          floatingTooltip.style.opacity = '0';
        }
      }
    });
  });

  // Cross-format hover preview and cover switching in Novidades section
  initNovidadesFormatHover();
}

/**
 * FEATURE #6.1: Cross-Format Hover Preview & Switching in "Novidades" Section
 * Temporarily morphs the 3D book cover when hovering over alternative format buttons.
 */
function initNovidadesFormatHover() {
  const cardsConfig = [
    {
      cardId: 'novidadesCardLeft',
      bookId: '2',
      defaultFormat: 'ebook',
      bookObjId: 'novidadesBookLeft',
      tagId: 'novidadesTagLeft',
      badgeId: 'novidadesBadgeLeft',
      priceId: 'novidadesPriceLeft',
      specId: 'novidadesSpecLeft',
      ebookPrice: '€7.00',
      hardcopyPrice: 'Esgotado',
      ebookSpecPt: 'ePub & PDF • Leitura Imediata',
      ebookSpecEn: 'ePub & PDF • Instant Download',
      hardcopySpecPt: 'Edição Impressa Esgotada',
      hardcopySpecEn: 'Printed Edition Sold Out',
      ebookBadgePt: '📱 EDIÇÃO DIGITAL • E-BOOK',
      ebookBadgeEn: '📱 DIGITAL EDITION • E-BOOK',
      hardcopyBadgePt: '📖 LIVRO IMPRESSO • ESGOTADO',
      hardcopyBadgeEn: '📖 PRINTED BOOK • SOLD OUT',
      ebookTagPt: 'E-BOOK',
      ebookTagEn: 'E-BOOK',
      hardcopyTagPt: 'ESGOTADO',
      hardcopyTagEn: 'SOLD OUT'
    },
    {
      cardId: 'novidadesCardRight',
      bookId: '9',
      defaultFormat: 'hardcopy',
      bookObjId: 'novidadesBookRight',
      tagId: 'novidadesTagRight',
      badgeId: 'novidadesBadgeRight',
      priceId: 'novidadesPriceRight',
      specId: 'novidadesSpecRight',
      ebookPrice: '€7.00',
      hardcopyPrice: '€10.00',
      ebookSpecPt: 'ePub & PDF • Leitura Imediata',
      ebookSpecEn: 'ePub & PDF • Instant Download',
      hardcopySpecPt: 'Nova Edição 2025 • Portes Grátis',
      hardcopySpecEn: 'New 2025 Edition • Free Shipping',
      ebookBadgePt: '📱 EDIÇÃO DIGITAL • E-BOOK',
      ebookBadgeEn: '📱 DIGITAL EDITION • E-BOOK',
      hardcopyBadgePt: '📖 LIVRO IMPRESSO • EXEMPLAR AUTOGRAFADO',
      hardcopyBadgeEn: '📖 PRINTED BOOK • AUTOGRAPHED COPY',
      ebookTagPt: 'E-BOOK',
      ebookTagEn: 'E-BOOK',
      hardcopyTagPt: 'LIVRO IMPRESSO',
      hardcopyTagEn: 'PRINTED BOOK'
    }
  ];

  cardsConfig.forEach(cfg => {
    const card = document.getElementById(cfg.cardId);
    if (!card) return;

    const bookObj = document.getElementById(cfg.bookObjId);
    const tag = document.getElementById(cfg.tagId);
    const badge = document.getElementById(cfg.badgeId);
    const price = document.getElementById(cfg.priceId);
    const spec = document.getElementById(cfg.specId);
    const btns = card.querySelectorAll('.novidades-btn-option');

    function applyFormat(fmt, triggerSweepAnim = false) {
      if (triggerSweepAnim && bookObj) {
        bookObj.classList.remove('trigger-sweep');
        void bookObj.offsetWidth; // force reflow
        bookObj.classList.add('trigger-sweep');
      }

      if (fmt === 'ebook') {
        if (bookObj) bookObj.classList.add('show-digital-cover');
        if (tag) {
          tag.textContent = (currentLang === 'en') ? cfg.ebookTagEn : cfg.ebookTagPt;
          tag.className = 'novidades-format-pill novidades-pill-ebook';
        }
        if (badge) {
          badge.textContent = (currentLang === 'en') ? cfg.ebookBadgeEn : cfg.ebookBadgePt;
          badge.className = 'format-badge format-badge-ebook';
        }
        if (price) price.textContent = cfg.ebookPrice;
        if (spec) spec.textContent = (currentLang === 'en') ? cfg.ebookSpecEn : cfg.ebookSpecPt;
      } else {
        if (bookObj) bookObj.classList.remove('show-digital-cover');
        if (tag) {
          tag.textContent = (currentLang === 'en') ? cfg.hardcopyTagEn : cfg.hardcopyTagPt;
          tag.className = 'novidades-format-pill novidades-pill-physical';
        }
        if (badge) {
          badge.textContent = (currentLang === 'en') ? cfg.hardcopyBadgeEn : cfg.hardcopyBadgePt;
          badge.className = 'format-badge format-badge-hardcopy';
        }
        if (price) price.textContent = cfg.hardcopyPrice;
        if (spec) spec.textContent = (currentLang === 'en') ? cfg.hardcopySpecEn : cfg.hardcopySpecPt;
      }
    }

    btns.forEach(btn => {
      const fmt = btn.getAttribute('data-format');

      btn.addEventListener('mouseenter', () => {
        btns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        applyFormat(fmt, true);
      });

      btn.addEventListener('mouseleave', () => {
        // Reset to default format
        btns.forEach(b => {
          if (b.getAttribute('data-format') === cfg.defaultFormat) {
            b.classList.add('active');
          } else {
            b.classList.remove('active');
          }
        });
        applyFormat(cfg.defaultFormat, false);
      });
    });
  });
}

/**
 * FEATURE #3: Interactive Literary Recommender Wizard ("O Leitor & a Obra")
 */
function initRecommenderWizard() {
  const stepBtns = document.querySelectorAll('.wizard-opt-btn');
  const resultBox = document.getElementById('wizardResultBox');
  const resultTitle = document.getElementById('recBookTitle');
  const resultGenre = document.getElementById('recBookGenre');
  const resultDesc = document.getElementById('recBookDesc');

  if (!resultBox) return;

  const recommendations = {
    perda: {
      bookId: "8",
      title: "Materna Doçura (1998)",
      genre_pt: "Romance Emblemático • Consagrado Internacionalmente",
      genre_en: "Emblematic Novel • Internationally Acclaimed",
      desc_pt: "Uma narrativa poética e tocante sobre perda, ausência e a busca de amor através da jornada inesquecível de Sacha.",
      desc_en: "A poetic and touching narrative about loss, absence, and the pursuit of love through Sacha's unforgettable journey."
    },
    rural: {
      bookId: "9",
      title: "Nylon da Minha Aldeia (1997 / 2025)",
      genre_pt: "Novela Literária • Adaptado ao Cinema",
      genre_en: "Literary Novella • Adapted into Cinema",
      desc_pt: "Uma imersão na memória afetiva e nas dinâmicas profundas de uma comunidade rural em transformação.",
      desc_en: "An immersion into emotional memory and the deep dynamics of a transforming rural community."
    },
    social: {
      bookId: "5",
      title: "O Meu Querido Titanic (2005)",
      genre_pt: "Crónicas Literárias • Observação Social",
      genre_en: "Literary Chronicles • Social Observation",
      desc_pt: "Crónicas acutilantes, irónicas e doces que observam com precisão os costumes e a sociedade portuguesa.",
      desc_en: "Sharp, ironic, and sweet chronicles acutely observing Portuguese customs and society."
    },
    distopia: {
      bookId: "1",
      title: "A Selva Dentro de Casa (2024)",
      genre_pt: "Novo Romance • Aclamado pela Crítica",
      genre_en: "New Novel • Critically Acclaimed",
      desc_pt: "Uma obra de forte intensidade emocional sobre a sobrevivência da inocência num mundo de contradições.",
      desc_en: "A work of intense emotional power exploring the survival of innocence in a world of contradictions."
    }
  };

  stepBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const mood = btn.getAttribute('data-mood');
      const rec = recommendations[mood] || recommendations.perda;

      if (resultTitle) resultTitle.textContent = rec.title;
      if (resultGenre) resultGenre.textContent = (currentLang === 'en') ? rec.genre_en : rec.genre_pt;
      if (resultDesc) resultDesc.textContent = (currentLang === 'en') ? rec.desc_en : rec.desc_pt;

      const recDetailBtn = document.getElementById('recBookDetailBtn');
      const recExcerptBtn = document.getElementById('recBookExcerptBtn');
      if (recDetailBtn) {
        recDetailBtn.setAttribute('data-book-id', rec.bookId);
      }
      if (recExcerptBtn) {
        recExcerptBtn.setAttribute('data-book-id', rec.bookId);
      }

      resultBox.style.display = 'block';
      resultBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  });

  const recDetailBtn = document.getElementById('recBookDetailBtn');
  const recExcerptBtn = document.getElementById('recBookExcerptBtn');
  if (recDetailBtn) {
    recDetailBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const id = recDetailBtn.getAttribute('data-book-id') || '8';
      openBookDetailModal(id);
    });
  }
  if (recExcerptBtn) {
    recExcerptBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const id = recExcerptBtn.getAttribute('data-book-id') || '8';
      openExcerptReader(id);
    });
  }
}

/**
 * Timeline Node Interactions
 */
function initTimelineInteractions() {
  const nodes = document.querySelectorAll('.timeline-node');
  
  nodes.forEach(node => {
    node.addEventListener('mouseenter', () => {
      nodes.forEach(n => n.classList.remove('active'));
      node.classList.add('active');
    });
  });
}

/**
 * Filterable Book Catalog
 */
function initBookFiltering() {
  const filterBtns = document.querySelectorAll('.filter-btn');
  const bookCards = document.querySelectorAll('.book-card');

  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      filterBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const filter = btn.getAttribute('data-filter');

      bookCards.forEach(card => {
        const category = card.getAttribute('data-category');
        if (filter === 'all' || category === filter) {
          card.style.display = 'flex';
          card.style.opacity = '1';
          card.style.transform = 'scale(1)';
        } else {
          card.style.opacity = '0';
          card.style.transform = 'scale(0.95)';
          setTimeout(() => {
            card.style.display = 'none';
          }, 200);
        }
      });
    });
  });
}

/**
 * FEATURE: Interactive Holographic Cover Morph Engine
 * Handles multi-format button hovers (Hardcopy, E-Book, Audiobook)
 * with GPU-accelerated diagonal holographic sheen sweep, smooth image cross-fade,
 * and live badge morphing.
 */
function initHoloCoverMorphEngine() {
  const cards = document.querySelectorAll('.book-card');

  cards.forEach(card => {
    const coverFrame = card.querySelector('.book-cover-frame');
    const badge = card.querySelector('.book-card-badge');
    const formatBtns = card.querySelectorAll('.btn-format');

    if (!coverFrame || formatBtns.length === 0) return;

    const defaultBadgeText = badge ? (badge.getAttribute('data-default-badge') || badge.textContent) : '';

    function triggerSweep() {
      coverFrame.classList.remove('trigger-sweep');
      // Force reflow for keyframe restart
      void coverFrame.offsetWidth;
      coverFrame.classList.add('trigger-sweep');
    }

    formatBtns.forEach(btn => {
      const format = btn.getAttribute('data-format');

      // Mouse Enter / Touch Interaction
      btn.addEventListener('mouseenter', () => {
        formatBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        if (format === 'ebook') {
          triggerSweep();
          coverFrame.classList.add('show-digital-cover');
          coverFrame.classList.remove('show-audiobook-overlay');
          if (badge) {
            const isSoon = btn.classList.contains('btn-coming-soon');
            badge.textContent = (currentLang === 'en')
              ? (isSoon ? '⚡ E-Book (Soon)' : '⚡ Digital E-Book')
              : (isSoon ? '⚡ E-Book (Brevemente)' : '⚡ E-Book Digital');
            badge.className = 'book-card-badge badge-ebook';
          }
        } else if (format === 'audiobook') {
          triggerSweep();
          coverFrame.classList.add('show-digital-cover');
          coverFrame.classList.add('show-audiobook-overlay');
          if (badge) {
            const isSoon = btn.classList.contains('btn-coming-soon');
            badge.textContent = (currentLang === 'en')
              ? (isSoon ? '🎧 Audiobook (Soon)' : '🎧 Audiobook')
              : (isSoon ? '🎧 Audiolivro (Brevemente)' : '🎧 Audiolivro');
            badge.className = 'book-card-badge badge-audiobook';
          }
        } else {
          // Hardcopy
          triggerSweep();
          coverFrame.classList.remove('show-digital-cover');
          coverFrame.classList.remove('show-audiobook-overlay');
          if (badge) {
            const isSoldOut = btn.classList.contains('btn-sold-out');
            if (isSoldOut) {
              badge.textContent = (currentLang === 'en') ? '📖 Sold Out' : '📖 Esgotado';
              badge.className = 'book-card-badge badge-sold-out';
            } else {
              badge.textContent = defaultBadgeText;
              badge.className = 'book-card-badge';
            }
          }
        }
      });
    });

    // Reset when cursor leaves the book card
    card.addEventListener('mouseleave', () => {
      formatBtns.forEach(b => b.classList.remove('active'));
      coverFrame.classList.remove('show-digital-cover');
      coverFrame.classList.remove('show-audiobook-overlay');
      if (badge) {
        badge.textContent = defaultBadgeText;
        badge.className = 'book-card-badge';
      }
    });
  });
}

/**
 * Interactive Book Detail Modal Engine
 */
function openBookDetailModal(id) {
  const bookDrawer = document.getElementById('bookDetailDrawer');
  const drawerOverlay = document.getElementById('drawerOverlay');
  if (!bookDrawer) return;

  const book = bookCatalogData[id] || bookCatalogData["1"];
  if (!book) return;

  closeAllDrawers();

  const modalTitle = document.getElementById('modalBookTitle');
  const modalMeta = document.getElementById('modalBookMeta');
  const modalSynopsis = document.getElementById('modalBookSynopsis');
  const modalCoverFrame = document.getElementById('modalCoverFrame');
  const modalCoverPhysical = document.getElementById('modalCoverPhysical');
  const modalCoverDigital = document.getElementById('modalCoverDigital');
  const modalAudioOverlay = document.getElementById('modalAudioOverlay');
  const modalFormatsRow = document.getElementById('modalFormatsRow');
  const modalExcerptBtn = document.getElementById('modalExcerptBtn');
  const modalRetailers = document.getElementById('modalRetailersList');
  const modalRetailersWrap = document.getElementById('modalBookRetailers');

  const genre = (currentLang === 'en') ? book.genre_en : book.genre_pt;
  const synopsis = (currentLang === 'en') ? book.synopsis_en : book.synopsis_pt;

  if (modalTitle) modalTitle.textContent = book.title;
  if (modalMeta) {
    let metaExtra = '';
    if (id === '2') metaExtra = (currentLang === 'en') ? ' • 3 FORMATS' : ' • 3 FORMATOS';
    else if (id === '9') metaExtra = (currentLang === 'en') ? ' • 2 FORMATS' : ' • 2 FORMATOS';
    modalMeta.textContent = `${book.year} • ${genre}${metaExtra}`;
  }
  if (modalSynopsis) modalSynopsis.textContent = synopsis;

  // Reset cover frame state
  if (modalCoverFrame) {
    modalCoverFrame.classList.remove('show-digital-cover', 'trigger-sweep');
  }
  if (modalAudioOverlay) {
    modalAudioOverlay.style.display = 'none';
  }

  // Configure Cover Images
  if (modalCoverPhysical && book.cover) {
    modalCoverPhysical.src = book.cover;
  }
  if (modalCoverDigital) {
    modalCoverDigital.src = book.cover_digital || book.cover;
  }

  // Helper function to trigger modal cover sheen sweep
  function triggerModalCoverMorph(showDigital, showAudio) {
    if (!modalCoverFrame) return;
    modalCoverFrame.classList.remove('trigger-sweep');
    void modalCoverFrame.offsetWidth; // force reflow
    modalCoverFrame.classList.add('trigger-sweep');

    if (showDigital) {
      modalCoverFrame.classList.add('show-digital-cover');
    } else {
      modalCoverFrame.classList.remove('show-digital-cover');
    }

    if (modalAudioOverlay) {
      modalAudioOverlay.style.display = showAudio ? 'flex' : 'none';
    }
  }

  // Populate Format Action Buttons
  if (modalFormatsRow) {
    modalFormatsRow.innerHTML = '';
    
    const threeFormatIds = ['2', '3', '4', '5', '6', '7', '8'];
    if (threeFormatIds.includes(id)) {
      // 3 Formats: Physical Autographed, E-Book Digital, Audiobook
      modalFormatsRow.className = 'modal-formats-row three-formats';
      
      const isHardcopySoldOut = (id === '2' || book.hardcopySoldOut || book.price === 'Esgotado');
      const isHardcopyAvailable = (['3', '4', '6', '8'].includes(id) && book.price !== 'Brevemente' && !isHardcopySoldOut);
      
      let hardcopyPrice = book.price || '€10.00';
      let hardcopyStatusClass = '';
      let hardcopyOrderAttr = 'data-open-order';

      if (isHardcopySoldOut) {
        hardcopyPrice = (currentLang === 'en') ? 'Sold Out' : 'Esgotado';
        hardcopyStatusClass = 'btn-sold-out';
        hardcopyOrderAttr = '';
      } else if (!isHardcopyAvailable) {
        hardcopyPrice = (currentLang === 'en') ? 'Coming Soon' : 'Brevemente';
        hardcopyStatusClass = 'btn-coming-soon';
        hardcopyOrderAttr = '';
      }

      const isEbookAvailable = (id === '2' && book.price_ebook !== 'Brevemente');
      const ebookPrice = isEbookAvailable 
        ? (book.price_ebook || '€7.00')
        : ((currentLang === 'en') ? 'Coming Soon' : 'Brevemente');
      const ebookSoonClass = isEbookAvailable ? '' : 'btn-coming-soon';
      const ebookOrderAttr = isEbookAvailable ? 'data-open-order' : '';

      const audioSoonText = (currentLang === 'en') ? 'Coming Soon' : 'Brevemente';

      modalFormatsRow.innerHTML = `
        <button class="modal-btn-format btn-hardcopy ${hardcopyStatusClass}" ${hardcopyOrderAttr} data-book-id="${id}" data-format="hardcopy">
          <span class="m-format-tag">📖 ${(currentLang === 'en') ? 'Hardcopy' : 'Livro Impresso'}</span>
          <span class="m-format-price">${hardcopyPrice}</span>
        </button>
        <button class="modal-btn-format btn-ebook ${ebookSoonClass}" ${ebookOrderAttr} data-book-id="${id}" data-format="ebook">
          <span class="m-format-tag">📱 ${(currentLang === 'en') ? 'Digital E-Book' : 'E-Book Digital'}</span>
          <span class="m-format-price">${ebookPrice}</span>
        </button>
        <button class="modal-btn-format btn-audiobook btn-coming-soon" data-book-id="${id}" data-format="audiobook">
          <span class="m-format-tag">🎧 ${(currentLang === 'en') ? 'Audiobook' : 'Audiolivro'}</span>
          <span class="m-format-price">${audioSoonText}</span>
        </button>
      `;

      // Attach hover morphing
      const btnHard = modalFormatsRow.querySelector('.btn-hardcopy');
      const btnEb = modalFormatsRow.querySelector('.btn-ebook');
      const btnAu = modalFormatsRow.querySelector('.btn-audiobook');

      if (btnEb) {
        btnEb.addEventListener('mouseenter', () => triggerModalCoverMorph(true, false));
        btnEb.addEventListener('mouseleave', () => triggerModalCoverMorph(false, false));
      }
      if (btnAu) {
        btnAu.addEventListener('mouseenter', () => triggerModalCoverMorph(true, true));
        btnAu.addEventListener('mouseleave', () => triggerModalCoverMorph(false, false));
      }
      if (btnHard) {
        btnHard.addEventListener('mouseenter', () => triggerModalCoverMorph(false, false));
      }

    } else if (id === '9') {
      // 2 Formats: Physical Autographed & E-Book
      modalFormatsRow.className = 'modal-formats-row two-formats';
      modalFormatsRow.innerHTML = `
        <button class="modal-btn-format btn-hardcopy" data-open-order data-book-id="9" data-format="hardcopy">
          <span class="m-format-tag">📖 ${(currentLang === 'en') ? 'Autographed Hardcopy' : 'Livro Impresso Autografado'}</span>
          <span class="m-format-price">${book.price || '€10.00'}</span>
        </button>
        <button class="modal-btn-format btn-ebook" data-open-order data-book-id="9" data-format="ebook">
          <span class="m-format-tag">📱 ${(currentLang === 'en') ? 'Digital E-Book' : 'E-Book Digital'}</span>
          <span class="m-format-price">${book.price_ebook || '€7.00'}</span>
        </button>
      `;

      // Attach hover morphing
      const btnHard = modalFormatsRow.querySelector('.btn-hardcopy');
      const btnEb = modalFormatsRow.querySelector('.btn-ebook');

      if (btnEb) {
        btnEb.addEventListener('mouseenter', () => triggerModalCoverMorph(true, false));
        btnEb.addEventListener('mouseleave', () => triggerModalCoverMorph(false, false));
      }
      if (btnHard) {
        btnHard.addEventListener('mouseenter', () => triggerModalCoverMorph(false, false));
      }

    } else {
      modalFormatsRow.className = 'modal-formats-row';
      modalFormatsRow.innerHTML = '';
    }

    // Direct click handler for order buttons in modal
    const newOrderBtns = modalFormatsRow.querySelectorAll('[data-open-order]');
    newOrderBtns.forEach(obtn => {
      obtn.addEventListener('click', (ev) => {
        ev.preventDefault();
        const targetFormat = obtn.getAttribute('data-format');
        const targetId = obtn.getAttribute('data-book-id');
        openOrderDrawerForBook(targetId, targetFormat);
      });
    });
  }

  // Configure Excerpt Sample Button
  if (modalExcerptBtn) {
    modalExcerptBtn.setAttribute('data-book-id', id);
    modalExcerptBtn.setAttribute('data-book-title', book.title);

    if (id !== '1') {
      modalExcerptBtn.className = 'btn-secondary modal-sample-btn';
      modalExcerptBtn.innerHTML = `
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>
        <span>${(currentLang === 'en') ? 'Read Sample Excerpt' : 'Ler Excerto de Amostra'}</span>
      `;
    } else {
      // Bookstore exclusive — prominent primary button
      modalExcerptBtn.className = 'btn-primary modal-sample-btn-prominent';
      modalExcerptBtn.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>
        <span>${(currentLang === 'en') ? 'Read Sample Excerpt →' : 'Ler Excerto de Amostra →'}</span>
      `;
    }

    modalExcerptBtn.onclick = (e) => {
      e.preventDefault();
      closeAllDrawers();
      openExcerptReader(id);
    };
  }

  // Populate Subtle, Quiet Bookstore Retailer Pills
  if (modalRetailers && modalRetailersWrap) {
    modalRetailers.innerHTML = '';
    if (book.links && book.links.length > 0) {
      book.links.forEach(link => {
        const a = document.createElement('a');
        a.href = link.url;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.className = 'subtle-retailer-pill';
        a.innerHTML = `<span>${link.name}</span><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>`;
        modalRetailers.appendChild(a);
      });
      modalRetailersWrap.style.display = 'flex';
    } else {
      modalRetailersWrap.style.display = 'none';
    }
  }

  bookDrawer.classList.add('open');
  if (drawerOverlay) drawerOverlay.classList.remove('open');
}

function initBookModalControls() {
  const detailBtns = document.querySelectorAll('[data-book-detail]');
  detailBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const id = btn.getAttribute('data-book-id');
      if (id) {
        openBookDetailModal(id);
      }
    });
  });
}

/**
 * Complete Dual Language Toggle Engine (PT | EN)
 */
function initLanguageToggle() {
  const langPt = document.getElementById('langPt');
  const langEn = document.getElementById('langEn');
  const mobileLangPt = document.getElementById('mobileLangPt');
  const mobileLangEn = document.getElementById('mobileLangEn');

  if (!langPt || !langEn) return;

  const translations = {
    pt: {
      navBio: "BIOGRAFIA",
      navCinema: "CINEMA",
      navDestaque: "DESTAQUE",
      navObras: "LIVROS",
      navCart: "CARRINHO",
      navImprensa: "IMPRENSA",
      navMediaKit: "MEDIA KIT",
      eyebrowHero: "ESCRITOR • ARGUMENTISTA • REALIZADOR",
      taglineHero: '"A escrita é a tentativa de dar forma àquilo que na vida é fugidio, silêncio e memória."',
      bioHero: "Autor de uma vasta obra literária que atravessa a ficção, o cinema e o teatro. A sua escrita destaca-se pela atenção às relações humanas, à memória, à identidade e à intensidade emocional.",
      btnExplore: "Explorar Obra Literária →",
      btnCinema: "Trabalhos de Cinema",
      metricBooks: "Obras Publicadas",
      metricAwardTitle: "Prémio Sophia",
      metricAward: "Melhor Canção Cinema",
      metricTranslations: "Traduções Europeias",
      bioDividerBtn: "✦ BIOGRAFIA & CRONOLOGIA ▼",
      timelineEyebrow: "A LINHA DO TEMPO DA CRIAÇÃO",
      timelineTitle: "O Percurso do Autor",
      timelineSubtitle: "Passe o cursor sobre os nós da linha do tempo para explorar os grandes marcos da sua bibliografia.",
      node1Desc: "Estreia na ficção literária sobre o meio rural. Adaptada ao cinema em 2012.",
      node1Tag: "Novela / Cinema",
      node2Desc: "Romance emblemático de perda e identidade que consagrou o autor internacionalmente.",
      node2Tag: "Romance Consagrado",
      node3Desc: "Crónicas doces e sarcásticas que observam com acutilância a sociedade portuguesa.",
      node3Tag: "Crónicas",
      node4Desc: "Narrativa intensa sobre as ligações profundas entre a natureza e a família humana.",
      node4Tag: "Romance",
      node5Desc: "O mais recente romance sobre a memória, a violência velada e os segredos da infância.",
      node5Tag: "Lançamento 2024",
      node6Desc: "Lançamento da nova edição revista da emblemática novela de estreia.",
      node6Tag: "Nova Edição 2025",
      pillar1Title: "Memória & Identidade",
      pillar1Desc: "A busca de sentido nas relações íntimas, investigando a ausência e o tempo que molda as personagens.",
      pillar2Title: "O Íntimo vs. O Social",
      pillar2Desc: "A observação subtil e por vezes irónica das forças invisíveis da sociedade e do quotidiano.",
      pillar3Title: "Precisão Pictórica",
      pillar3Desc: "Uma escrita contida e cinematográfica que presentifica os seres e as coisas com grande densidade emocional.",
      chapterLabel: "EXCERTO DO LIVRO",
      btnFullChapter: "Ler Excerto Completo →",
      featuredEyebrow: "Romance mais recente (2024)",
      featuredDesc: "Enquanto o tio e a lembrança dos dias felizes o abandonam, esta criança-narrador enfrenta o desafio de sobreviver num país marcado por outras formas de violência, a começar pela que existe no seio da sua própria família.",
      quoteText: '"Um texto belíssimo e tocante, feito de doses iguais de ternura e de violência..."',
      btnBuy: "Comprar Exemplar — €18.00 →",
      btnRead: "Ler Excerto",
      recEyebrow: "RECOMENDADOR LITERÁRIO",
      recTitle: "Descubra a Sua Próxima Leitura",
      recSubtitle: "Selecione a atmosfera literária que procura hoje para descobrir a obra ideal do autor para si.",
      mood1Title: "Intimidade & Perda",
      mood1Desc: "Jornadas emocionais, memória e redescoberta de afeto",
      mood2Title: "Memória Rural & Tradição",
      mood2Desc: "Transformations de uma comunidade e percursos individuais",
      mood3Title: "Satírica & Crónica Social",
      mood3Desc: "Observação acutilante, irónica e doce da sociedade",
      mood4Title: "Intensidade Distópica",
      mood4Desc: "Luta pela sobrevivência num mundo em transformação",
      recResultHeader: "RECOMENDAÇÃO PERSONALIZADA:",
      btnOrderThis: "Encomendar Este Livro — €10.00 →",
      btnReadSample: "Ler Amostra",
      cinemaEyebrow: "LITERATURA & CINEMA",
      cinemaTitle: "O Olhar Cinematográfico",
      cinemaSubtitle: "Embora consagrado como um dos mais talentosos escritores da língua portuguesa, Possidónio Cachapa tem uma vasta e distinta carreira como argumentista e realizador.",
      film1Award: "PRÉMIO SOPHIA — MELHOR CANÇÃO PARA CINEMA",
      film1Role: "Argumento & Letras de Música Originais",
      film1Desc: "Longa-metragem de animação aclamada internacionalmente. Possidónio Cachapa escreveu o argumento e a letra da música original, vencedora do prestigiado Prémio Sophia da Academia Portuguesa de Cinema em conjunto com o compositor.",
      film2Award: "IRIS AWARDS NOMINEE",
      film2Role: "Ficção • Adaptado do Romance de Estreia",
      film2Desc: "Adaptação cinematográfica do emblemático romance rural do autor. Nomeado para os prestigiados prémios internacionais Iris Awards, celebrando a transição entre o texto literário e a linguagem do ecrã.",
      film3Award: "DOCUMENTÁRIO DE AUTOR",
      film3Role: "Realização & Argumento",
      film3Desc: "Obra documental de forte densidade poética e sensibilidade visual. O próprio clip em vídeo deste filme reproduz em fundo nesta secção, revelando o seu olhar autoral.",
      catalogEyebrow: "CATÁLOGO EDITORIAL COMPLETO",
      catalogTitle: "Obras Publicadas",
      catalogSubtitle: "Explore a lista completa dos 9 principais livros do autor, com sinopses e detalhes editoriais.",
      filterAll: "TODOS OS LIVROS",
      filterRomance: "ROMANCES",
      filterNovela: "NOVELAS",
      filterCronica: "CRÓNICAS",
      btnBookDetail: "Ver Detalhes & Sinopse",
      pressEyebrow: "CRÍTICA LITERÁRIA",
      pressTitle: "Reconhecimento da Imprensa",
      pressSubtitle: "A crítica tem destacado a construção de personagens densas, a atenção às dinâmicas íntimas e a sobriedade estilística da sua obra.",

      // Distinct Subject Badges & Labels
      lblAboutBook: "sobre o livro",
      badgeAuthorCritique: "Crítica de Autor",

      // Press Carousel Quotes Translation
      pQuote1: "Um romance a sério, magistralmente escrito.",
      pQuote2: "Uma leitura devoradora.",
      pQuote3: "Possidónio Cachapa tem um universo.",
      pQuote4: "A arte de Possidónio Cachapa consiste no modo como presentifica os seres e as coisas.",
      pQuote5: "Um texto belíssimo e tocante, feito de doses iguais de ternura e de violência...",
      pQuote6: "Uma voz singular da nova literatura portuguesa, com um olhar agudíssimo sobre a memória comunitária.",

      excerptEyebrow: "EXCERTO EXCLUSIVO",
      bookDetailEyebrow: "FICHA DE LIVRO",
      lblRetailers: "Disponível também nas livrarias:",
      lblRetailersSubtle: "Também disponível em:",
      lblComingSoon: "Brevemente",
      lblSoldOut: "Esgotado",
      orderEyebrow: "CARRINHO & ENCOMENDA",
      orderTitle: "Encomendar Livro",
      orderShipping: "Portes de Envio (Portugal Continental)",
      orderFree: "Grátis",
      autographCheckbox: "Desejo um exemplar assinado pelo autor (Grátis)",
      autographNameLabel: "Nome do leitor para quem o autor assina:",
      btnFinalizeOrder: "Finalizar Encomenda (€10.00) →",
      btnAddToCart: "Adicionar ao Carrinho",
      cartEyebrow: "CARRINHO & ENCOMENDA",
      cartTitle: "O Seu Carrinho",
      cartSubtitle: "Reveja as suas obras selecionadas antes de finalizar a encomenda com o autor.",
      cartBackToCatalog: "Voltar ao Catálogo de Livros",
      cartColBook: "Obra Literária",
      cartColQty: "Qtd.",
      cartColTotal: "Total",
      cartRemove: "Remover",
      cartSummaryTitle: "Resumo do Pedido",
      cartSubtotal: "Subtotal",
      cartShipping: "Portes de Envio (Portugal Continental)",
      cartAutographService: "Dedicatória & Autógrafo",
      cartTotal: "Total a Pagar",
      cartProceedCheckout: "Finalizar Encomenda →",
      cartContinueShopping: "Continuar a Comprar Livros",
      cartSecurityNote: "Pagamento 100% Seguro Shopify • MB WAY, Cartão de Crédito e Multibanco",
      cartEmptyTitle: "O seu carrinho está vazio",
      cartEmptyDesc: "Ainda não adicionou nenhum livro ao seu carrinho. Explore a vasta obra literária de Possidónio Cachapa e encomende exemplares autografados diretamente com o autor.",
      cartEmptyBtn: "Explorar Catálogo de Livros →",
      mediaKitEyebrow: "IMPRENSA & COMUNICAÇÃO",
      mediaKitTitle: "Media Kit Oficial",
      mediaKitBioTitle: "Biografia Oficial & Filmografia",
      mediaKitBioBody: "Possidónio Cachapa é escritor, argumentista e realizador português. A sua obra literária e cinematográfica destaca-se pela profunda sensibilidade humana. No cinema, escreveu o argumento e as letras originais de Os Demónios do Meu Avô (vencedor do Prémio Sophia da Academia Portuguesa de Cinema para Melhor Canção), realizou e escreveu o documentário Adeus à Brisa (2013), e viu o seu romance de estreia Nylon da Minha Aldeia adaptado ao ecrã (2012, Iris Awards Nominee).",
      mediaKitResTitle: "Recursos Oficiais",
      resPhoto: "Fotografia de Autor (Alta Resolução)",
      resVideo: "Clip de Filme: Adeus à Brisa (HD Video)",
      resPdf: "Dossiê de Imprensa Completo (PDF)",

      // 9 Books Catalog Synopses & Genres
      b1Genre: "Romance • 2024",
      b1Synopsis: "Enquanto o tio e a lembrança dos dias felizes o abandonam, esta criança-narrador enfrenta o desafio de sobreviver num país marcado por outras formas de violência...",
      b2Genre: "Romance • 2019",
      b2Synopsis: "Um olhar contemporâneo sobre o papel da mulher, a expressão da sua sexualidade e a visão que a família e a sociedade mantêm sobre ela...",
      b3Genre: "Romance • 2016",
      b3Synopsis: "Entre os homens e as árvores há tanto em comum que por vezes não se sabe onde começam uns e acabam os outros...",
      b4Genre: "Romance Distópico • 2009",
      b4Synopsis: "Romance distópico sobre um mundo onde o consumismo e a luta pelo poder atraem o gelo e a neve...",
      b5Genre: "Crónicas • 2005",
      b5Synopsis: "Livro de crónicas ora doces ora sarcásticas que deixam o país a nu. E que tem pena de o fazer...",
      b6Genre: "Romance • 2002",
      b6Synopsis: "Romance de uma intensidade feroz, capaz de abalar a nossa visão do mundo, das pessoas e do amor...",
      b7Genre: "Romance • 1999 / 2015",
      b7Synopsis: "Através da viagem interior de Kika, a que tudo vê; esta obra explora o tempo e o desire humano...",
      b8Genre: "Romance Consagrado • 1998",
      b8Synopsis: "Uma história de perda e identidade, Sacha, uma criança órfã de mãe embarca numa jornada emocional para reencontrar o amor...",
      b9Genre: "Novela • 1997 / 2025",
      b9Synopsis: "Ficção de estreia que combina memória afetiva e crítica social. Adaptada ao cinema em 2012, relançada em nova edição 2025...",

      // Novidades Section Translations
      navNovidades: "NOVIDADES",
      novidadesTitle: "NOVIDADES NA LOJA",
      novidadesSubtitle: "Exemplares impressos autografados com dedicatória personalizada e novas edições digitais prontas para leitura imediata.",
      novidadesLabelEbook: "E-BOOK",
      novidadesLabelPhysical: "LIVRO IMPRESSO",
      novidadesOptionEbook: "📱 E-Book",
      novidadesOptionHardcopy: "📖 Livro Impresso",
      novidadesBoasBadge: "📱 EDIÇÃO DIGITAL • E-BOOK",
      novidadesBoasSpec: "ePub & PDF • Leitura Imediata",
      novidadesBoasDesc: "Um olhar contemporâneo sobre o papel da mulher, a expressão da sua sexualidade e a visão que a sociedade mantém sobre ela. Agora em formato digital oficial de autor para e-readers, tablets e smartphones.",
      novidadesBoasBuy: "Comprar E-Book — €7.00 →",
      novidadesNylonBadge: "📖 LIVRO IMPRESSO • EXEMPLAR AUTOGRAFADO",
      novidadesNylonSpec: "Nova Edição 2025 • Portes Grátis",
      novidadesNylonDesc: "O aclamado romance de estreia de Possidónio Cachapa, adaptado ao cinema. Disponível diretamente com o autor nesta nova tiragem impressa, com dedicatória personalizada e portes gratuitos em Portugal.",
      novidadesNylonBuy: "Encomendar Autografado — €10.00 →",
      novidadesReadExcerpt: "Ler Excerto",
      clickToFlipHint: "Clique no livro para folhear",
      audioLabel: "MÚSICA AMBIENTE",
      heroMusicInvite: "✦ É melhor com música ...",
      heroMusicPlaying: "✦ Experiência Sonora Ativa ♫",
      floatingMusicLabel: "MÚSICA",
      musicPopoverEyebrow: "MÚSICA AMBIENTE",
      musicVolumeLabel: "Volume",
      musicTurnOff: "Desligar Música",
      musicTurnOn: "Ativar Música"
    },
    en: {
      navBio: "BIOGRAPHY",
      navCinema: "CINEMA",
      navDestaque: "FEATURED",
      navObras: "BOOKS",
      navCart: "CART",
      navImprensa: "PRESS",
      navMediaKit: "MEDIA KIT",
      eyebrowHero: "AUTHOR • SCREENWRITER • FILM DIRECTOR",
      taglineHero: '"Writing is an attempt to give shape to what in life is fleeting, silent, and remembered."',
      bioHero: "Author of an extensive literary work spanning fiction, cinema, and theatre. His writing stands out for its deep attention to human relationships, memory, identity, and emotional intensity.",
      btnExplore: "Explore Literary Work →",
      btnCinema: "Film & Cinema Work",
      metricBooks: "Published Works",
      metricAwardTitle: "Sophia Award",
      metricAward: "Best Cinema Song",
      metricTranslations: "European Translations",
      bioDividerBtn: "✦ BIOGRAPHY & TIMELINE ▼",
      timelineEyebrow: "THE TIMELINE OF CREATION",
      timelineTitle: "The Author's Journey",
      timelineSubtitle: "Hover over the timeline nodes to explore key milestones in his bibliography.",
      node1Desc: "Debut literary fiction on rural life. Adapted to cinema in 2012.",
      node1Tag: "Novella / Cinema",
      node2Desc: "Emblematic novel of loss and identity that established the author internationally.",
      node2Tag: "Acclaimed Novel",
      node3Desc: "Sweet and sarcastic chronicles acutely observing Portuguese society.",
      node3Tag: "Chronicles",
      node4Desc: "Poetic exploration of human nature and fertile family roots.",
      node4Tag: "Novel",
      node5Desc: "Latest work, critically acclaimed for its poetic and emotional intensity.",
      node5Tag: "New Novel",
      node6Desc: "Release of the new revised edition of the author's debut work.",
      node6Tag: "New Edition",
      pillar1Title: "Memory & Identity",
      pillar1Desc: "The search for meaning in intimate relationships, investigating absence and time.",
      pillar2Title: "The Intimate vs. The Social",
      pillar2Desc: "Subtle and sharp observation of the invisible forces of society and daily life.",
      pillar3Title: "Cinematic Precision",
      pillar3Desc: "Restrained and cinematic prose bringing beings and things to life with emotional density.",
      chapterLabel: "BOOK EXCERPT",
      btnFullChapter: "Read Full Excerpt →",
      featuredEyebrow: "LATEST NOVEL (2024)",
      featuredDesc: "As his uncle and memories of happy days leave him, this young narrator faces the challenge of surviving in a country marked by violence, starting within his own family.",
      quoteText: '"A beautiful and touching text, made of equal doses of tenderness and violence..."',
      btnBuy: "Order Book — €18.00 →",
      btnRead: "Read Excerpt",
      recEyebrow: "LITERARY RECOMMENDER",
      recTitle: "Discover Your Next Read",
      recSubtitle: "Select the literary atmosphere you are looking for today to discover your ideal book by the author.",
      mood1Title: "Intimacy & Loss",
      mood1Desc: "Emotional journeys, memory, and rediscovery of affection",
      mood2Title: "Rural Memory & Tradition",
      mood2Desc: "Transformations of a community and individual paths",
      mood3Title: "Satirical & Social Chronicles",
      mood3Desc: "Sharp, ironic, and sweet observation of society",
      mood4Title: "Dystopian Intensity",
      mood4Desc: "Survival in a world under transformation",
      recResultHeader: "PERSONALIZED RECOMMENDATION:",
      btnOrderThis: "Order This Book — €10.00 →",
      btnReadSample: "Read Sample",
      cinemaEyebrow: "LITERATURE & CINEMA",
      cinemaTitle: "The Cinematic Vision",
      cinemaSubtitle: "Although celebrated as one of the most talented contemporary Portuguese writers, Possidónio Cachapa has a distinguished career as a screenwriter and film director.",
      film1Award: "SOPHIA AWARD — BEST SONG FOR CINEMA",
      film1Role: "Screenplay & Original Song Lyrics",
      film1Desc: "Internationally acclaimed animated feature film. Possidónio Cachapa wrote the screenplay and original song lyrics, winning the prestigious Sophia Award from the Portuguese Academy of Cinema.",
      film2Award: "IRIS AWARDS NOMINEE",
      film2Role: "Fiction Film • Adapted from Debut Novel",
      film2Desc: "Film adaptation of the author's iconic rural novel. Nominated for the Iris Awards, celebrating the bridge between literature and cinema.",
      film3Award: "AUTEUR DOCUMENTARY",
      film3Role: "Director & Screenwriter",
      film3Desc: "Documentary work of rich poetic density and visual sensitivity. The video clip of this film plays in the background of this section.",
      catalogEyebrow: "COMPLETE CATALOG",
      catalogTitle: "Published Books",
      catalogSubtitle: "Explore the complete catalog of 9 major books by the author, featuring synopses and publication details.",
      filterAll: "ALL BOOKS",
      filterRomance: "NOVELS",
      filterNovela: "NOVELLAS",
      filterCronica: "CHRONICLES",
      btnBookDetail: "View Details & Synopsis",
      pressEyebrow: "LITERARY REVIEWS",
      pressTitle: "Press & Critical Acclaim",
      pressSubtitle: "Critics have highlighted his complex characters, attention to intimate dynamics, and stylistic elegance.",

      // Distinct Subject Badges & Labels in English
      lblAboutBook: "on the novel",
      badgeAuthorCritique: "General Author Review",

      // Press Carousel Quotes English Translation
      pQuote1: "A serious novel, masterfully written.",
      pQuote2: "A devouring read.",
      pQuote3: "Possidónio Cachapa has a universe of his own.",
      pQuote4: "The art of Possidónio Cachapa lies in the way he brings beings and things into vivid presence.",
      pQuote5: "A beautiful and touching text, crafted from equal measures of tenderness and violence...",
      pQuote6: "A singular voice in modern Portuguese literature, with an acute eye for community memory.",

      excerptEyebrow: "EXCLUSIVE EXCERPT",
      bookDetailEyebrow: "BOOK DETAILS",
      lblRetailers: "Also available at partner bookstores:",
      lblRetailersSubtle: "Also available at:",
      lblComingSoon: "Coming Soon",
      lblSoldOut: "Sold Out",
      orderEyebrow: "CART & CHECKOUT",
      orderTitle: "Order Book",
      orderShipping: "Shipping (Mainland Portugal)",
      orderFree: "Free",
      autographCheckbox: "I would like a copy signed by the author (Free)",
      autographNameLabel: "Name of the reader for the signature:",
      btnFinalizeOrder: "Complete Order (€10.00) →",
      btnAddToCart: "Add to Cart",
      cartEyebrow: "CART & ORDER",
      cartTitle: "Your Shopping Cart",
      cartSubtitle: "Review your selected books before finalizing your order with the author.",
      cartBackToCatalog: "Back to Book Catalog",
      cartColBook: "Literary Work",
      cartColQty: "Qty.",
      cartColTotal: "Total",
      cartRemove: "Remove",
      cartSummaryTitle: "Order Summary",
      cartSubtotal: "Subtotal",
      cartShipping: "Shipping (Mainland Portugal)",
      cartAutographService: "Custom Dedication & Autograph",
      cartTotal: "Total Due",
      cartProceedCheckout: "Proceed to Checkout →",
      cartContinueShopping: "Continue Browsing Books",
      cartSecurityNote: "100% Secure Shopify Checkout • Cards, MB WAY & Multibanco",
      cartEmptyTitle: "Your cart is empty",
      cartEmptyDesc: "You haven't added any books to your cart yet. Explore Possidónio Cachapa's literary work and order autographed copies directly with the author.",
      cartEmptyBtn: "Explore Book Catalog →",
      mediaKitEyebrow: "PRESS & COMMUNICATIONS",
      mediaKitTitle: "Official Media Kit",
      mediaKitBioTitle: "Official Bio & Filmography",
      mediaKitBioBody: "Possidónio Cachapa is a Portuguese writer, screenwriter, and film director. His literary and cinematic work stands out for its deep human sensitivity. In cinema, he wrote the screenplay and original lyrics for Os Demónios do Meu Avô (winner of the Sophia Award for Best Song), directed and wrote the documentary Adeus à Brisa (2013), and saw his debut novel Nylon da Minha Aldeia adapted for the screen (2012, Iris Awards Nominee).",
      mediaKitResTitle: "Official Resources",
      resPhoto: "Author Portrait (High Resolution)",
      resVideo: "Film Clip: Adeus à Brisa (HD Video)",
      resPdf: "Complete Press Kit (PDF)",

      // 9 Books Catalog Synopses & Genres in English
      b1Genre: "Novel • 2024",
      b1Synopsis: "As his uncle and memories of happy days leave him, this child narrator faces the challenge of surviving in a country marked by other forms of violence...",
      b2Genre: "Novel • 2019",
      b2Synopsis: "A contemporary reflection on women's roles, the expression of female sexuality, and the perceptions maintained by family and society over time...",
      b3Genre: "Novel • 2016",
      b3Synopsis: "There is so much in common between men and trees that sometimes it is hard to tell where one ends and the other begins...",
      b4Genre: "Dystopian Novel • 2009",
      b4Synopsis: "A dystopian novel about a world where consumerism and the struggle for power bring forth ice and snow...",
      b5Genre: "Chronicles • 2005",
      b5Synopsis: "A collection of sweet yet sarcastic chronicles exposing the country with a touch of tender pity...",
      b6Genre: "Novel • 2002",
      b6Synopsis: "A novel of fierce intensity, capable of shaking our vision of the world, people, and love...",
      b7Genre: "Novel • 1999 / 2015",
      b7Synopsis: "Through the inner journey of Kika, the all-seeing; this work explores time and human desire...",
      b8Genre: "Acclaimed Novel • 1998",
      b8Synopsis: "A story of loss and identity, Sacha, a young motherless child, embarks on an emotional journey to rediscover love...",
      b9Genre: "Novella • 1997 / 2025",
      b9Synopsis: "An intense narrative centered on the life and transformations of a rural community, combining emotional memory and social critique...",

      // Novidades Section Translations
      navNovidades: "NEW RELEASES",
      novidadesTitle: "NEW IN STORE",
      novidadesSubtitle: "Autographed hardcopies with custom personal dedication and new author digital editions ready for instant reading.",
      novidadesLabelEbook: "E-BOOK",
      novidadesLabelPhysical: "PRINTED BOOK",
      novidadesOptionEbook: "📱 E-Book",
      novidadesOptionHardcopy: "📖 Printed Book",
      novidadesBoasBadge: "📱 DIGITAL EDITION • E-BOOK",
      novidadesBoasSpec: "ePub & PDF • Instant Download",
      novidadesBoasDesc: "A contemporary reflection on women's roles, the expression of female sexuality, and the perceptions maintained by society. Now available in official digital author format for e-readers, tablets, and phones.",
      novidadesBoasBuy: "Buy E-Book — €7.00 →",
      novidadesNylonBadge: "📖 PRINTED BOOK • AUTOGRAPHED COPY",
      novidadesNylonSpec: "New 2025 Edition • Free Shipping",
      novidadesNylonDesc: "Possidónio Cachapa's acclaimed debut novel, adapted for cinema. Available directly from the author in this new print run, with complimentary personalized dedication and free shipping in Portugal.",
      novidadesNylonBuy: "Order Autographed Copy — €10.00 →",
      novidadesReadExcerpt: "Read Excerpt",
      clickToFlipHint: "Click book to open pages",
      audioLabel: "AMBIENT MUSIC",
      heroMusicInvite: "✦ Better with music ...",
      heroMusicPlaying: "✦ Soundscape Active ♫",
      floatingMusicLabel: "MUSIC",
      musicPopoverEyebrow: "AMBIENT SOUNDTRACK",
      musicVolumeLabel: "Volume",
      musicTurnOff: "Turn Off Music",
      musicTurnOn: "Turn On Music"
    }
  };

  function applyLanguage(lang) {
    currentLang = lang;
    const data = translations[lang];
    if (!data) return;

    if (lang === 'pt') {
      langPt.classList.add('active-lang');
      langEn.classList.remove('active-lang');
      if (mobileLangPt) {
        mobileLangPt.classList.add('active-lang');
        mobileLangEn.classList.remove('active-lang');
      }
    } else {
      langEn.classList.add('active-lang');
      langPt.classList.remove('active-lang');
      if (mobileLangEn) {
        mobileLangEn.classList.add('active-lang');
        mobileLangPt.classList.remove('active-lang');
      }
    }

    // Update all elements with data-i18n
    document.querySelectorAll('[data-i18n]').forEach(el => {
      const key = el.getAttribute('data-i18n');
      if (data[key]) {
        el.textContent = data[key];
      }
    });

    // Update Bio Divider Button if expanded/collapsed
    const timelineSection = document.getElementById('linha-do-tempo');
    const dividerBtn = document.querySelector('.bio-divider-btn');
    if (timelineSection && dividerBtn) {
      if (timelineSection.classList.contains('expanded')) {
        dividerBtn.innerHTML = (lang === 'en') ? '✦ HIDE BIOGRAPHY ▲' : '✦ OCULTAR BIOGRAFIA ▲';
      } else {
        dividerBtn.innerHTML = (lang === 'en') ? '✦ BIOGRAPHY & TIMELINE ▼' : '✦ BIOGRAFIA & CRONOLOGIA ▼';
      }
    }

    // Update Floating Cursor Tooltip
    const floatingTooltip = document.getElementById('bookFloatingTooltip');
    const bookObject = document.getElementById('hardcoverBookObj');
    if (floatingTooltip && bookObject) {
      if (!bookObject.classList.contains('open')) {
        floatingTooltip.textContent = (lang === 'en') ? 'Click to open' : 'Clique para abrir';
      }
    }

    // Update Hero Audio Invite Button Text based on playing state
    const heroInviteBtn = document.getElementById('heroAudioInviteBtn');
    const heroInviteText = document.getElementById('heroAudioInviteText');
    if (heroInviteText) {
      const isPlaying = heroInviteBtn && heroInviteBtn.classList.contains('active-playing');
      heroInviteText.textContent = isPlaying
        ? ((lang === 'en') ? '✦ Soundscape Active ♫' : '✦ Experiência Sonora Ativa ♫')
        : ((lang === 'en') ? '✦ Better with music ...' : '✦ É melhor com música ...');
    }

    // Update Music Action Button Text based on paused/playing state
    const musicActionBtn = document.getElementById('musicActionBtn');
    const musicActionBtnText = document.getElementById('musicActionBtnText');
    if (musicActionBtn && musicActionBtnText) {
      const isOff = musicActionBtn.classList.contains('is-off');
      musicActionBtnText.textContent = isOff
        ? ((lang === 'en') ? 'Turn On Music' : 'Ativar Música')
        : ((lang === 'en') ? 'Turn Off Music' : 'Desligar Música');
    }

    // Update Book Card Badges
    document.querySelectorAll('.book-card').forEach(card => {
      const bId = card.getAttribute('data-book-id');
      const badge = card.querySelector('.book-card-badge');
      if (bId && badge && bookCatalogData[bId]) {
        const book = bookCatalogData[bId];
        const newBadgeText = (lang === 'en') ? book.badge_en : book.badge_pt;
        badge.textContent = newBadgeText;
        badge.setAttribute('data-default-badge', newBadgeText);
      }
    });
  }

  langPt.addEventListener('click', () => applyLanguage('pt'));
  langEn.addEventListener('click', () => applyLanguage('en'));
  if (mobileLangPt) mobileLangPt.addEventListener('click', () => applyLanguage('pt'));
  if (mobileLangEn) mobileLangEn.addEventListener('click', () => applyLanguage('en'));
}

/**
 * Mobile Navigation Drawer Engine
 */
function initMobileMenu() {
  const toggleBtn = document.getElementById('mobileMenuToggle');
  const drawer = document.getElementById('mobileNavDrawer');
  const overlay = document.getElementById('mobileNavOverlay');
  const closeBtn = document.getElementById('mobileNavClose');
  const navLinks = document.querySelectorAll('.mobile-nav-link');
  const mobileBioLink = document.getElementById('mobileNavBioLink');
  const timelineSection = document.getElementById('linha-do-tempo');
  const dividerBtn = document.querySelector('.bio-divider-btn');

  if (!toggleBtn || !drawer) return;

  function openMenu() {
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  toggleBtn.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('open')) {
      closeMenu();
    }
  });

  navLinks.forEach(link => {
    link.addEventListener('click', () => {
      closeMenu();
    });
  });

  if (mobileBioLink && timelineSection) {
    mobileBioLink.addEventListener('click', (e) => {
      e.preventDefault();
      closeMenu();
      if (!timelineSection.classList.contains('expanded')) {
        timelineSection.classList.add('expanded');
        if (dividerBtn) {
          dividerBtn.innerHTML = (typeof currentLang !== 'undefined' && currentLang === 'en') ? '✦ HIDE BIOGRAPHY ▲' : '✦ OCULTAR BIOGRAFIA ▲';
        }
      }
      setTimeout(() => {
        timelineSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 350);
    });
  }
}

/**
 * Smooth Drawer Toggle Controls
 */
function openExcerptReader(bookId = "1", bookTitle = null) {
  let book = bookCatalogData[bookId];
  if (!book && bookTitle) {
    book = Object.values(bookCatalogData).find(b => b.title === bookTitle);
  }
  if (!book) book = bookCatalogData["1"];

  closeAllDrawers();

  const excerptReader = document.getElementById('excerptReader');

  // Header Elements
  const headerTitle = document.querySelector('.excerpt-header-book');
  const headerChapter = document.querySelector('.excerpt-header-chapter');
  const headerSeparator = document.querySelector('.excerpt-header-separator');
  const mainTitle = document.querySelector('.excerpt-book-title');
  const mainChapter = document.querySelector('.excerpt-chapter-label');
  const mainDivider = document.querySelector('.excerpt-chapter-divider');
  const parchment = document.querySelector('.excerpt-parchment');
  const buyBtn = document.querySelector('.excerpt-buy-btn');

  if (headerTitle) headerTitle.textContent = book.title;
  if (mainTitle) mainTitle.textContent = book.title;

  const hasChapter = book.excerpt && book.excerpt.hasChapterTitle;
  const chapterName = (book.excerpt && hasChapter)
    ? ((currentLang === 'en' && book.excerpt.chapter_en) ? book.excerpt.chapter_en : (book.excerpt.chapter_pt || book.excerpt.chapter))
    : '';

  if (headerChapter) {
    if (hasChapter && chapterName) {
      headerChapter.textContent = chapterName;
      headerChapter.style.display = 'inline';
      if (headerSeparator) headerSeparator.style.display = 'inline';
    } else {
      headerChapter.textContent = (currentLang === 'en') ? 'EXCERPT' : 'EXCERTO';
      headerChapter.style.display = 'inline';
      if (headerSeparator) headerSeparator.style.display = 'inline';
    }
  }

  if (mainChapter) {
    if (hasChapter && chapterName) {
      mainChapter.textContent = chapterName;
      mainChapter.style.display = 'block';
      if (mainDivider) mainDivider.style.display = 'block';
    } else {
      mainChapter.style.display = 'none';
      if (mainDivider) mainDivider.style.display = 'none';
    }
  }

  // Populate paragraphs with Drop Cap and Gradient Fade Out
  if (parchment && book.excerpt && book.excerpt.paragraphs) {
    parchment.innerHTML = '';
    const paragraphs = book.excerpt.paragraphs;
    paragraphs.forEach((pText, idx) => {
      const p = document.createElement('p');
      const isLast = (idx === paragraphs.length - 1);

      if (idx === 0) {
        const firstChar = pText.charAt(0);
        const rest = pText.slice(1);
        p.innerHTML = `<span class="excerpt-dropcap">${firstChar}</span>${rest}`;
      } else {
        p.textContent = pText;
      }

      if (isLast && book.excerpt.hasFadeOut) {
        p.classList.add('excerpt-fade-out');
      }
      parchment.appendChild(p);
    });

    if (book.excerpt.hasFadeOut) {
      const teaser = document.createElement('div');
      teaser.className = 'excerpt-continuation-box';
      teaser.innerHTML = `<span>✦ Fim do excerto da página • A narrativa continua no livro completo ✦</span>`;
      parchment.appendChild(teaser);
    }
  }

  // Configure buy CTA button
  if (buyBtn) {
    buyBtn.setAttribute('data-book-id', bookId);
    buyBtn.setAttribute('data-book-title', book.title);

    if (book.salesType === 'ebook') {
      buyBtn.classList.remove('btn-coming-soon');
      buyBtn.textContent = (currentLang === 'en') ? `Buy E-Book (${book.price_ebook || book.price}) →` : `Comprar E-Book (${book.price_ebook || book.price}) →`;
      buyBtn.onclick = (ev) => {
        ev.preventDefault();
        openOrderDrawerForBook(bookId, 'ebook');
      };
    } else if ((book.salesType === 'direct_physical' || book.salesType === 'direct_both') && book.price !== 'Brevemente') {
      buyBtn.classList.remove('btn-coming-soon');
      buyBtn.textContent = (currentLang === 'en') ? `Order Autographed Copy (${book.price}) →` : `Encomendar Exemplar Autografado (${book.price}) →`;
      buyBtn.onclick = (ev) => {
        ev.preventDefault();
        openOrderDrawerForBook(bookId, 'hardcopy');
      };
    } else if (book.salesType === 'coming_soon' || book.price === 'Brevemente') {
      buyBtn.classList.add('btn-coming-soon');
      buyBtn.textContent = (currentLang === 'en') ? 'Direct Order Coming Soon' : 'Encomenda Direta Brevemente';
      buyBtn.onclick = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        showToast((currentLang === 'en') ? `"${book.title}" will be available for direct order soon.` : `"${book.title}" estará brevemente disponível para encomenda direta com o autor.`);
      };
    } else {
      // Bookstore exclusive
      buyBtn.classList.remove('btn-coming-soon');
      buyBtn.textContent = (currentLang === 'en') ? 'Available in Partner Bookstores →' : 'Ver nas Livrarias Parceiras →';
      buyBtn.onclick = (ev) => {
        ev.preventDefault();
        closeAllDrawers();
        openBookDetailModal(bookId);
      };
    }
  }

  if (excerptReader) {
    excerptReader.classList.add('open');
    document.body.style.overflow = 'hidden';
    const scroll = excerptReader.querySelector('.excerpt-reader-scroll');
    if (scroll) scroll.scrollTop = 0;
  }
}

function openOrderDrawerForBook(bookId, format = 'hardcopy') {
  const orderDrawer = document.getElementById('orderDrawer');
  const overlay = document.getElementById('drawerOverlay');
  if (!orderDrawer || !overlay) return;

  const matchedBook = bookCatalogData[bookId];
  if (!matchedBook) {
    console.warn('Unknown book ID for order drawer:', bookId);
    return;
  }

  // Safety guard: allow direct order for all books currently in stock (IDs 2, 3, 4, 6, 8, 9)
  const directOrderBookIds = ['2', '3', '4', '6', '8', '9'];
  if (matchedBook.salesType === 'coming_soon' || matchedBook.price === 'Brevemente' || !directOrderBookIds.includes(bookId)) {
    showToast((currentLang === 'en') ? `"${matchedBook.title}" will be available for direct order soon.` : `"${matchedBook.title}" estará brevemente disponível para encomenda direta com o autor.`);
    return;
  }

  // Guard: book 2 physical edition is sold out
  if (bookId === '2' && format === 'hardcopy') {
    showToast((currentLang === 'en') ? 'The physical printed copy of this book is sold out. Available in E-Book!' : 'O exemplar impresso deste livro encontra-se esgotado. Disponível em formato E-Book!');
    return;
  }

  closeAllDrawers();

  const isEbook = (format === 'ebook');
  const isAudiobook = (format === 'audiobook');
  const isDigital = isEbook || isAudiobook;

  let activePrice = matchedBook.price || '€10.00';
  if (isEbook) activePrice = matchedBook.price_ebook || '€7.00';
  if (isAudiobook) activePrice = matchedBook.price_audiobook || '€9.90';

  const nameElem = document.getElementById('orderDrawerBookName');
  const priceElem = document.getElementById('orderDrawerBookPrice');
  const formatElem = document.getElementById('orderDrawerFormatBadge');
  const shippingLabel = document.getElementById('orderDrawerShippingLabel');
  const shippingVal = document.getElementById('orderDrawerShippingVal');
  const autographBox = document.getElementById('orderDrawerAutographBox');
  const submitBtn = document.getElementById('orderDrawerSubmitBtn');
  const retailersWrap = document.getElementById('orderDrawerRetailersWrap');
  const retailersList = document.getElementById('orderDrawerRetailersList');

  const variantInput = document.getElementById('orderDrawerVariantId');
  if (variantInput && orderDrawer) {
    const nylonVariant = orderDrawer.getAttribute('data-nylon-variant-id') || '52695798677843';
    const nylonEbookVariant = orderDrawer.getAttribute('data-nylon-ebook-variant-id') || '54808934646099';
    const boasVariant = orderDrawer.getAttribute('data-boas-variant-id') || '54764192432467';
    const boasPhysicalVariant = orderDrawer.getAttribute('data-boas-physical-variant-id') || '54791075594579';
    const arvoreVariant = orderDrawer.getAttribute('data-arvore-variant-id') || '54791134445907';
    const coelhoVariant = orderDrawer.getAttribute('data-coelho-variant-id') || '54808394891603';
    const marVariant = orderDrawer.getAttribute('data-mar-variant-id') || '54791100891475';
    const docuraVariant = orderDrawer.getAttribute('data-docura-variant-id') || '54791130087763';

    if (bookId === '9' || matchedBook.title.includes('Nylon')) {
      variantInput.value = isDigital ? nylonEbookVariant : nylonVariant;
    } else if (bookId === '2' || matchedBook.title.includes('Esposas')) {
      variantInput.value = isDigital ? boasVariant : boasPhysicalVariant;
    } else if (bookId === '3' || matchedBook.title.includes('Árvore')) {
      variantInput.value = arvoreVariant;
    } else if (bookId === '4' || matchedBook.title.includes('Coelho')) {
      variantInput.value = coelhoVariant;
    } else if (bookId === '6' || matchedBook.title.includes('Mar')) {
      variantInput.value = marVariant;
    } else if (bookId === '8' || matchedBook.title.includes('Doçura')) {
      variantInput.value = docuraVariant;
    } else {
      variantInput.value = '';
    }
  }

  if (nameElem) {
    if (isAudiobook) {
      nameElem.textContent = (currentLang === 'en') ? `Audiobook "${matchedBook.title}"` : `Audiolivro "${matchedBook.title}"`;
    } else if (isEbook) {
      nameElem.textContent = (currentLang === 'en') ? `E-Book "${matchedBook.title}"` : `E-Book "${matchedBook.title}"`;
    } else {
      nameElem.textContent = (currentLang === 'en') ? `Book "${matchedBook.title}"` : `Livro "${matchedBook.title}"`;
    }
  }
  if (priceElem) {
    priceElem.textContent = activePrice;
  }
  if (formatElem) {
    if (isAudiobook) {
      formatElem.textContent = (currentLang === 'en') ? 'Audiobook (Narrated Edition)' : 'Audiolivro (Edição Narrada)';
    } else if (isEbook) {
      formatElem.textContent = (currentLang === 'en') ? 'Digital Edition (ePub / PDF)' : 'Edição Digital (ePub / PDF)';
    } else {
      formatElem.textContent = (currentLang === 'en') ? 'Hardcopy Book (Autographed)' : 'Livro Impresso (Exemplar Autografado)';
    }
  }
  if (shippingLabel && shippingVal) {
    if (isAudiobook) {
      shippingLabel.textContent = (currentLang === 'en') ? 'Access' : 'Acesso';
      shippingVal.textContent = (currentLang === 'en') ? 'Instant Digital Stream & Audio Download' : 'Acesso Imediato & Download de Áudio';
    } else if (isEbook) {
      shippingLabel.textContent = (currentLang === 'en') ? 'Delivery' : 'Entrega';
      shippingVal.textContent = (currentLang === 'en') ? 'Instant Download (Email)' : 'Download Imediato (E-mail)';
    } else {
      shippingLabel.textContent = (currentLang === 'en') ? 'Shipping (Mainland Portugal)' : 'Portes de Envio (Portugal Continental)';
      shippingVal.textContent = (currentLang === 'en') ? 'Free' : 'Grátis';
    }
  }
  if (autographBox) {
    autographBox.style.display = isDigital ? 'none' : 'block';
  }
  if (submitBtn) {
    submitBtn.textContent = (currentLang === 'en')
      ? `Complete Order (${activePrice}) →`
      : `Finalizar Encomenda (${activePrice}) →`;
  }

  if (retailersList && retailersWrap) {
    retailersList.innerHTML = '';
    if (matchedBook.links && matchedBook.links.length > 0) {
      matchedBook.links.forEach(link => {
        const a = document.createElement('a');
        a.href = link.url;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.className = 'subtle-retailer-pill';
        a.innerHTML = `<span>${link.name}</span><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>`;
        retailersList.appendChild(a);
      });
      retailersWrap.style.display = 'flex';
    } else {
      retailersWrap.style.display = 'none';
    }
  }

  orderDrawer.classList.add('open');
  overlay.classList.add('open');
}

function initDrawerToggles() {
  const overlay = document.getElementById('drawerOverlay');
  const closeBtns = document.querySelectorAll('.close-drawer, [data-close-drawer]');
  const excerptBtn = document.querySelectorAll('[data-open-excerpt]');
  const mediaKitBtn = document.querySelectorAll('[data-open-mediakit]');
  const orderBtns = document.querySelectorAll('[data-open-order]');
  const mediaKitDrawer = document.getElementById('mediaKitDrawer');

  excerptBtn.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const bookId = btn.getAttribute('data-book-id') || "1";
      const bookTitle = btn.getAttribute('data-book-title');
      openExcerptReader(bookId, bookTitle);
    });
  });

  mediaKitBtn.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      closeAllDrawers();
      if (mediaKitDrawer && overlay) {
        mediaKitDrawer.classList.add('open');
        overlay.classList.add('open');
      }
    });
  });

  orderBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const idAttr = btn.getAttribute('data-book-id');
      const formatAttr = btn.getAttribute('data-format') || 'hardcopy';
      openOrderDrawerForBook(idAttr, formatAttr);
    });
  });

  // Seamless Shopify AJAX Cart Form Handler with Direct Checkout Redirect
  const orderForm = document.getElementById('orderDrawerForm');
  if (orderForm) {
    orderForm.addEventListener('submit', function(e) {
      const submitBtn = document.getElementById('orderDrawerSubmitBtn');
      const variantInput = document.getElementById('orderDrawerVariantId');
      const autographInput = document.getElementById('autographNameInput');
      const autographCheckbox = document.getElementById('autographCheckboxInput');

      if (variantInput && variantInput.value) {
        e.preventDefault();
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = (currentLang === 'en') ? 'Redirecting to Checkout...' : 'A redirecionar para o pagamento...';
        }

        const formData = new FormData();
        formData.append('id', variantInput.value);
        formData.append('quantity', '1');

        if (autographCheckbox && autographCheckbox.checked && autographInput && autographInput.value.trim()) {
          formData.append('properties[Dedicatória Para]', autographInput.value.trim());
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          if (response.ok) {
            window.location.href = '/checkout';
          } else {
            // Fallback to regular form submission if AJAX returns error
            orderForm.submit();
          }
        })
        .catch(() => {
          // If running locally or network fails, fallback to regular submit
          orderForm.submit();
        });
      }
    });
  }

  // Dedicated "Adicionar ao Carrinho" (Add to Cart) Button Handler
  const addCartBtn = document.getElementById('orderDrawerAddCartBtn');
  if (addCartBtn) {
    addCartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const variantInput = document.getElementById('orderDrawerVariantId');
      const autographInput = document.getElementById('autographNameInput');
      const autographCheckbox = document.getElementById('autographCheckboxInput');
      const textSpan = document.getElementById('orderDrawerAddCartText');

      if (variantInput && variantInput.value) {
        addCartBtn.disabled = true;
        const originalText = textSpan ? textSpan.textContent : '';
        if (textSpan) {
          textSpan.textContent = (currentLang === 'en') ? 'Adding...' : 'A adicionar...';
        }

        const formData = new FormData();
        formData.append('id', variantInput.value);
        formData.append('quantity', '1');

        if (autographCheckbox && autographCheckbox.checked && autographInput && autographInput.value.trim()) {
          formData.append('properties[Dedicatória Para]', autographInput.value.trim());
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          if (!response.ok) throw new Error('Cart add response not ok');
          return response.json();
        })
        .then(data => {
          addCartBtn.classList.add('added');
          if (textSpan) {
            textSpan.textContent = (currentLang === 'en') ? '✓ Added to Cart!' : '✓ Adicionado!';
          }

          // Update header cart count badges
          fetch('/cart.js')
          .then(res => res.json())
          .then(cartData => {
            const countBadges = document.querySelectorAll('.header-cart-badge');
            countBadges.forEach(badge => {
              badge.textContent = cartData.item_count;
              if (cartData.item_count > 0) {
                badge.classList.remove('cart-badge-empty');
              }
            });
          })
          .catch(() => {});

          const bookNameElem = document.getElementById('orderDrawerBookName');
          const bookTitle = bookNameElem ? bookNameElem.textContent.replace(/^Livro\s*|^Book\s*|"/g, '').trim() : '';
          const toastMsg = (currentLang === 'en')
            ? `"${bookTitle}" added to your cart.`
            : `"${bookTitle}" adicionado ao carrinho com sucesso.`;
          showToast(toastMsg);

          setTimeout(() => {
            addCartBtn.disabled = false;
            addCartBtn.classList.remove('added');
            if (textSpan) {
              textSpan.textContent = (currentLang === 'en') ? 'Add to Cart' : 'Adicionar ao Carrinho';
            }
            closeAllDrawers();
          }, 1200);
        })
        .catch(err => {
          console.warn('Cart add error (or demo mode):', err);
          addCartBtn.classList.add('added');
          if (textSpan) {
            textSpan.textContent = (currentLang === 'en') ? '✓ Added (Demo)' : '✓ Adicionado (Demo)';
          }
          const countBadges = document.querySelectorAll('.header-cart-badge');
          countBadges.forEach(badge => {
            const currentCount = parseInt(badge.textContent || '0', 10);
            badge.textContent = currentCount + 1;
            badge.classList.remove('cart-badge-empty');
          });
          const bookNameElem = document.getElementById('orderDrawerBookName');
          const bookTitle = bookNameElem ? bookNameElem.textContent.replace(/^Livro\s*|^Book\s*|"/g, '').trim() : '';
          showToast((currentLang === 'en') ? `"${bookTitle}" added to cart.` : `"${bookTitle}" adicionado ao carrinho com sucesso.`);
          setTimeout(() => {
            addCartBtn.disabled = false;
            addCartBtn.classList.remove('added');
            if (textSpan) {
              textSpan.textContent = (currentLang === 'en') ? 'Add to Cart' : 'Adicionar ao Carrinho';
            }
            closeAllDrawers();
          }, 1200);
        });
      }
    });
  }

  closeBtns.forEach(btn => {
    btn.addEventListener('click', closeAllDrawers);
  });

  if (overlay) {
    overlay.addEventListener('click', closeAllDrawers);
  }
}

function closeAllDrawers() {
  const drawers = document.querySelectorAll('.side-drawer');
  const modals = document.querySelectorAll('.book-detail-modal');
  const overlay = document.getElementById('drawerOverlay');
  const excerptReader = document.getElementById('excerptReader');

  drawers.forEach(d => d.classList.remove('open'));
  modals.forEach(m => m.classList.remove('open'));
  if (overlay) overlay.classList.remove('open');
  if (excerptReader) excerptReader.classList.remove('open');
  document.body.style.overflow = '';
}

/**
 * IMMERSIVE EXCERPT READER — Scroll Progress, Sticky Header & Keyboard Support
 */
function initExcerptReader() {
  const reader = document.getElementById('excerptReader');
  const scroll = document.getElementById('excerptReaderScroll');
  const header = document.getElementById('excerptReaderHeader');
  const closeBtn = document.getElementById('excerptCloseBtn');
  const progressFill = document.getElementById('excerptProgressFill');
  const progressLabel = document.getElementById('excerptProgressLabel');

  if (!reader || !scroll) return;

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      reader.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // Click on dark area / backdrop outside reading column to exit preview
  scroll.addEventListener('click', (e) => {
    const column = reader.querySelector('.excerpt-reader-column');
    if (e.target === scroll || (column && !column.contains(e.target))) {
      reader.classList.remove('open');
      document.body.style.overflow = '';
    }
  });

  reader.addEventListener('click', (e) => {
    const column = reader.querySelector('.excerpt-reader-column');
    const readerHeader = reader.querySelector('.excerpt-reader-header');
    if (e.target === reader || (!column?.contains(e.target) && !readerHeader?.contains(e.target))) {
      reader.classList.remove('open');
      document.body.style.overflow = '';
    }
  });

  // Escape key to close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && reader.classList.contains('open')) {
      reader.classList.remove('open');
      document.body.style.overflow = '';
    }
  });

  // Scroll progress tracking & sticky header
  scroll.addEventListener('scroll', () => {
    const scrollTop = scroll.scrollTop;
    const scrollHeight = scroll.scrollHeight - scroll.clientHeight;
    const progress = scrollHeight > 0 ? Math.min((scrollTop / scrollHeight) * 100, 100) : 0;

    // Update progress bar
    if (progressFill) {
      progressFill.style.width = progress.toFixed(1) + '%';
    }
    if (progressLabel) {
      progressLabel.textContent = Math.round(progress) + '%';
    }

    // Show sticky header after scrolling past chapter intro (~200px)
    if (header) {
      if (scrollTop > 200) {
        header.classList.add('visible');
      } else {
        header.classList.remove('visible');
      }
    }
  });
}

/**
 * Toast Notification & Coming Soon Interceptor
 */
function showToast(message) {
  let toast = document.getElementById('pcToast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'pcToast';
    toast.className = 'pc-toast';
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  toast.classList.add('show');
  clearTimeout(toast._timeout);
  toast._timeout = setTimeout(() => {
    toast.classList.remove('show');
  }, 2600);
}

document.addEventListener('click', (e) => {
  const soldOutBtn = e.target.closest('.btn-sold-out');
  if (soldOutBtn) {
    e.preventDefault();
    e.stopPropagation();
    const format = soldOutBtn.getAttribute('data-format');
    let label = (currentLang === 'en') ? 'The physical printed copy' : 'O exemplar impresso';
    if (format !== 'hardcopy') {
      label = (currentLang === 'en') ? 'This edition' : 'Esta edição';
    }
    const msg = (currentLang === 'en')
      ? `${label} is sold out. Available in E-Book!`
      : `${label} encontra-se esgotado. Disponível em E-Book!`;
    showToast(msg);
    return;
  }

  const comingSoonBtn = e.target.closest('.btn-coming-soon');
  if (comingSoonBtn) {
    e.preventDefault();
    e.stopPropagation();
    const format = comingSoonBtn.getAttribute('data-format');
    let label = 'Edição digital';
    if (format === 'audiobook') {
      label = (currentLang === 'en') ? 'Audiobook' : 'Audiolivro';
    } else if (format === 'hardcopy') {
      label = (currentLang === 'en') ? 'Hardcopy' : 'Livro Impresso';
    } else if (format === 'ebook') {
      label = 'E-Book';
    }
    const msg = (currentLang === 'en')
      ? `${label} coming soon!`
      : `${label} disponível brevemente!`;
    showToast(msg);
  }
});

/**
 * FEATURE: Seamless Atmospheric Ambient Audio Engine & Floating Controls
 * Plays Giacomo Puccini (La Rondine - Chi il bel sogno di Doretta)
 * - Rock-solid play / pause state tracking with immediate, synchronous audio.pause()
 * - Soft start with 2s gradient fade-in to reduced comfortable standard volume (0.12)
 * - Protected against asynchronous promise race conditions (activePlayId)
 * - Safe touch event handling: gesture listeners ignore taps on audio controls
 * - Floating circular music icon button that appears smoothly as user scrolls past hero
 * - Interactive popover card with volume slider (0-100%) and Turn Off / Turn On toggle
 */
function initAmbientAudioEngine() {
  const audio = document.getElementById('ambientAudio');
  const heroInviteBtn = document.getElementById('heroAudioInviteBtn');
  const heroInviteText = document.getElementById('heroAudioInviteText');
  const floatingWidget = document.getElementById('floatingMusicWidget');
  const floatingMusicBtn = document.getElementById('floatingMusicBtn');
  const musicPopoverCard = document.getElementById('musicPopoverCard');
  const musicPopoverClose = document.getElementById('musicPopoverClose');
  const musicVolumeSlider = document.getElementById('musicVolumeSlider');
  const volumeValueBadge = document.getElementById('volumeValueBadge');
  const musicActionBtn = document.getElementById('musicActionBtn');
  const musicActionBtnText = document.getElementById('musicActionBtnText');
  const musicActionBtnIcon = document.getElementById('musicActionBtnIcon');

  if (!audio) return;

  // Reduced, warm ambient standard volume for MacBook & iPhone speakers
  const DEFAULT_STANDARD_VOLUME = 0.12;
  const savedVol = sessionStorage.getItem('pc_audio_vol');
  let currentTargetVolume = savedVol !== null ? parseFloat(savedVol) : DEFAULT_STANDARD_VOLUME;
  if (isNaN(currentTargetVolume) || currentTargetVolume <= 0) currentTargetVolume = DEFAULT_STANDARD_VOLUME;
  if (currentTargetVolume > 1) currentTargetVolume = 1;

  let fadeInterval = null;
  let isUserMuted = sessionStorage.getItem('pc_audio_muted') === 'true';
  let isPlaying = false;
  let activePlayId = 0;

  // Sync with audio element's native events as single source of truth
  audio.addEventListener('play', () => {
    isPlaying = true;
    updateUIState(true);
  });

  audio.addEventListener('pause', () => {
    isPlaying = false;
    updateUIState(false);
  });

  audio.addEventListener('ended', () => {
    isPlaying = false;
    updateUIState(false);
  });

  // Initialize volume slider and badge
  if (musicVolumeSlider) {
    musicVolumeSlider.value = Math.round(currentTargetVolume * 100);
  }
  if (volumeValueBadge) {
    volumeValueBadge.textContent = `${Math.round(currentTargetVolume * 100)}%`;
  }

  function updateUIState(active) {
    // 1. Update Hero Invitation Button
    if (heroInviteBtn) {
      if (active) {
        heroInviteBtn.classList.add('active-playing');
        if (heroInviteText) {
          heroInviteText.textContent = (typeof currentLang !== 'undefined' && currentLang === 'en')
            ? '✦ Soundscape Active ♫'
            : '✦ Experiência Sonora Ativa ♫';
        }
      } else {
        heroInviteBtn.classList.remove('active-playing');
        if (heroInviteText) {
          heroInviteText.textContent = (typeof currentLang !== 'undefined' && currentLang === 'en')
            ? '✦ Better with music ...'
            : '✦ É melhor com música ...';
        }
      }
    }

    // 2. Update Floating Trigger Button
    if (floatingMusicBtn) {
      if (active) {
        floatingMusicBtn.classList.remove('paused');
        floatingMusicBtn.classList.add('playing');
        floatingMusicBtn.setAttribute('aria-label', (typeof currentLang !== 'undefined' && currentLang === 'en') ? 'Music playing. Click to adjust volume or turn off' : 'Música ativa. Clique para ajustar volume ou desligar');
      } else {
        floatingMusicBtn.classList.remove('playing');
        floatingMusicBtn.classList.add('paused');
        floatingMusicBtn.setAttribute('aria-label', (typeof currentLang !== 'undefined' && currentLang === 'en') ? 'Music paused. Click to turn on' : 'Música desligada. Clique para ativar');
      }
    }

    // 3. Update Popover Action Button (Turn Off vs Turn On)
    if (musicActionBtn && musicActionBtnText) {
      if (active) {
        musicActionBtn.classList.remove('is-off');
        musicActionBtnText.textContent = (typeof currentLang !== 'undefined' && currentLang === 'en')
          ? 'Turn Off Music'
          : 'Desligar Música';
        if (musicActionBtnIcon) {
          musicActionBtnIcon.innerHTML = `
            <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="6" y="4" width="4" height="16"></rect>
              <rect x="14" y="4" width="4" height="16"></rect>
            </svg>`;
        }
      } else {
        musicActionBtn.classList.add('is-off');
        musicActionBtnText.textContent = (typeof currentLang !== 'undefined' && currentLang === 'en')
          ? 'Turn On Music'
          : 'Ativar Música';
        if (musicActionBtnIcon) {
          musicActionBtnIcon.innerHTML = `
            <svg viewBox="0 0 24 24" width="13" height="13" fill="currentColor" stroke="none">
              <polygon points="5 3 19 12 5 21 5 3"></polygon>
            </svg>`;
        }
      }
    }
  }

  function updateVolumeUI(vol) {
    const pct = Math.round(vol * 100);
    if (volumeValueBadge) volumeValueBadge.textContent = `${pct}%`;
    if (musicVolumeSlider && document.activeElement !== musicVolumeSlider) {
      musicVolumeSlider.value = pct;
    }
  }

  // Smooth gradient fade-in bounded by step counter (works on all browsers)
  function fadeIn(target = currentTargetVolume, durationMs = 2000) {
    clearInterval(fadeInterval);
    const targetVol = Math.max(0.02, Math.min(1, target));

    try {
      audio.volume = 0;
    } catch (e) {}

    let step = 0;
    const totalSteps = 20;
    const stepTime = durationMs / totalSteps;
    const stepDelta = targetVol / totalSteps;

    fadeInterval = setInterval(() => {
      step++;
      if (isUserMuted || audio.paused) {
        clearInterval(fadeInterval);
        return;
      }
      try {
        const nextVol = Math.min(targetVol, step * stepDelta);
        audio.volume = nextVol;
      } catch (e) {
        clearInterval(fadeInterval);
      }
      if (step >= totalSteps) {
        try {
          audio.volume = targetVol;
        } catch (e) {}
        clearInterval(fadeInterval);
      }
      updateVolumeUI(targetVol);
    }, stepTime);
  }

  function playAudio() {
    isUserMuted = false;
    sessionStorage.setItem('pc_audio_muted', 'false');
    clearInterval(fadeInterval);
    cleanupGestureListeners();

    if (currentTargetVolume <= 0) {
      currentTargetVolume = DEFAULT_STANDARD_VOLUME;
      updateVolumeUI(DEFAULT_STANDARD_VOLUME);
    }

    const thisPlayId = ++activePlayId;

    try {
      audio.volume = 0;
    } catch (e) {}

    const promise = audio.play();
    if (promise !== undefined) {
      promise
        .then(() => {
          // If user clicked stop while play request was pending, immediately pause!
          if (thisPlayId !== activePlayId || isUserMuted) {
            audio.pause();
            isPlaying = false;
            updateUIState(false);
            return;
          }
          isPlaying = true;
          fadeIn(currentTargetVolume, 2000);
          updateUIState(true);
        })
        .catch(err => {
          if (thisPlayId === activePlayId) {
            console.log('Ambient audio play blocked:', err.message);
            isPlaying = false;
            updateUIState(false);
          }
        });
    } else {
      isPlaying = true;
      fadeIn(currentTargetVolume, 2000);
      updateUIState(true);
    }
  }

  function pauseAudio() {
    isUserMuted = true;
    sessionStorage.setItem('pc_audio_muted', 'true');
    clearInterval(fadeInterval);
    cleanupGestureListeners();
    activePlayId++; // Cancel any pending play promises

    try {
      audio.pause();
    } catch (e) {
      console.warn('Audio pause error:', e);
    }

    isPlaying = false;
    updateUIState(false);
  }

  function togglePlayPause() {
    if (isPlaying && !audio.paused) {
      pauseAudio();
    } else {
      playAudio();
    }
  }

  // Dismiss attract mouse gesture guide on user interaction
  const gestureGuide = document.getElementById('heroClickGestureGuide');
  function dismissGestureGuide() {
    if (gestureGuide && gestureGuide.style.display !== 'none') {
      gestureGuide.style.opacity = '0';
      gestureGuide.style.transition = 'opacity 0.3s ease';
      setTimeout(() => {
        try { gestureGuide.style.display = 'none'; } catch (err) {}
      }, 300);
    }
  }

  // Hero invitation button click
  if (heroInviteBtn) {
    heroInviteBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      dismissGestureGuide();
      togglePlayPause();
    });
    heroInviteBtn.addEventListener('mouseenter', dismissGestureGuide, { once: true });
    heroInviteBtn.addEventListener('touchstart', dismissGestureGuide, { once: true, passive: true });
  }

  // Floating trigger button click: toggle popover controls
  if (floatingMusicBtn && musicPopoverCard) {
    floatingMusicBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isOpen = musicPopoverCard.classList.contains('open');
      if (isOpen) {
        musicPopoverCard.classList.remove('open');
        floatingMusicBtn.setAttribute('aria-expanded', 'false');
      } else {
        musicPopoverCard.classList.add('open');
        floatingMusicBtn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  // Popover close button
  if (musicPopoverClose && musicPopoverCard) {
    musicPopoverClose.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      musicPopoverCard.classList.remove('open');
      if (floatingMusicBtn) floatingMusicBtn.setAttribute('aria-expanded', 'false');
    });
  }

  // Popover inner click containment
  if (musicPopoverCard) {
    musicPopoverCard.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }

  // Close popover when clicking anywhere outside
  document.addEventListener('click', (e) => {
    if (musicPopoverCard && musicPopoverCard.classList.contains('open')) {
      if (!musicPopoverCard.contains(e.target) && !floatingMusicBtn.contains(e.target)) {
        musicPopoverCard.classList.remove('open');
        if (floatingMusicBtn) floatingMusicBtn.setAttribute('aria-expanded', 'false');
      }
    }
  });

  // Action Button inside Popover (Turn Off / Turn On)
  if (musicActionBtn) {
    musicActionBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      togglePlayPause();
    });
  }

  // Volume Slider input handler (Real-time adjustment)
  if (musicVolumeSlider) {
    musicVolumeSlider.addEventListener('input', (e) => {
      const val = parseInt(e.target.value, 10) / 100;
      currentTargetVolume = val;
      sessionStorage.setItem('pc_audio_vol', val.toString());
      updateVolumeUI(val);

      if (val === 0) {
        pauseAudio();
      } else {
        clearInterval(fadeInterval);
        try {
          audio.volume = val;
        } catch (err) {}
        if (audio.paused || !isPlaying) {
          playAudio();
        } else {
          updateUIState(true);
        }
      }
    });
  }

  // Scroll listener: display floating music widget when user scrolls past hero invite button
  if (floatingWidget && heroInviteBtn) {
    const handleScrollVisibility = () => {
      const rect = heroInviteBtn.getBoundingClientRect();
      // When hero invite button has scrolled up out of view or scrollY > 260
      if (rect.bottom < 20 || window.scrollY > 260) {
        floatingWidget.classList.add('visible');
      } else {
        floatingWidget.classList.remove('visible');
        if (musicPopoverCard) musicPopoverCard.classList.remove('open');
        if (floatingMusicBtn) floatingMusicBtn.setAttribute('aria-expanded', 'false');
      }
    };

    window.addEventListener('scroll', handleScrollVisibility, { passive: true });
    // Initial check
    handleScrollVisibility();
  }

  // Attempt play or attach one-time user gesture listeners
  const startOnGesture = (e) => {
    // If user interacted directly with any audio control, do not trigger background autoplay
    if (e && e.target && (
      e.target.closest('#heroAudioInviteBtn') ||
      e.target.closest('#musicActionBtn') ||
      e.target.closest('#floatingMusicBtn') ||
      e.target.closest('#musicPopoverCard')
    )) {
      cleanupGestureListeners();
      return;
    }

    if (!isUserMuted && !isPlaying && audio.paused) {
      playAudio();
    }
    cleanupGestureListeners();
  };

  const cleanupGestureListeners = () => {
    ['click', 'touchstart', 'touchend', 'scroll', 'keydown'].forEach(ev => {
      document.removeEventListener(ev, startOnGesture, { passive: true });
    });
  };

  if (!isUserMuted) {
    playAudio();

    ['click', 'touchstart', 'touchend', 'scroll', 'keydown'].forEach(ev => {
      document.addEventListener(ev, startOnGesture, { once: true, passive: true });
    });
  } else {
    updateUIState(false);
  }
}

/**
 * Cross-Page Anchor Navigation Helper
 * Enables internal section anchor links (e.g. #novidades, #obras, #linha-do-tempo, #cinema)
 * to smoothly navigate back to the homepage when clicked from secondary pages like /cart.
 */
function initCrossPageAnchorNavigation() {
  document.addEventListener('click', (e) => {
    const anchor = e.target.closest('a[href*="#"]');
    if (!anchor) return;

    const href = anchor.getAttribute('href');
    if (!href || href === '#' || href.startsWith('javascript:')) return;

    // Extract hash part
    const hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;
    const hash = href.substring(hashIndex);
    const targetId = hash.substring(1);
    if (!targetId) return;

    // Check if target anchor exists in current document
    const targetEl = document.getElementById(targetId);

    // If target is NOT on current page (e.g. user is on /cart and clicks an anchor)
    if (!targetEl) {
      e.preventDefault();
      const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root
        : '/';
      const cleanRoot = rootUrl.endsWith('/') ? rootUrl : (rootUrl + '/');
      window.location.href = cleanRoot + hash;
    }
  });
}



